<template>
  <head>
    <meta charset="utf-8"/>
    <title>Field Enforcement | Business Verification</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="County Revenue Management System" name="description"/>
    <link href="assets/images/favicon.svg" rel="shortcut icon">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <link href="./assets/libs/owl.carousel/assets/owl.carousel.min.css" rel="stylesheet">
    <link href="./assets/libs/owl.carousel/assets/owl.theme.default.min.css" rel="stylesheet">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Field Enforcement &amp; Verification</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">Business Permits</a></li>
                    <li class="breadcrumb-item active">Enforcement</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <ToolBar/>

          <!-- Stats Cards -->
          <div class="row mb-3">
            <div class="col-lg-3 col-md-6 col-6">
              <div class="card mini-stats-wid border-0 shadow-sm">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1" style="font-size:12px;">Today's Inspections</p>
                      <h4 class="mb-0">{{ myStats.todayCount || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary bg-gradient">
                      <span class="avatar-title"><i class="bx bx-search-alt font-size-24"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-6">
              <div class="card mini-stats-wid border-0 shadow-sm">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1" style="font-size:12px;">This Week</p>
                      <h4 class="mb-0">{{ myStats.weekCount || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-info bg-gradient">
                      <span class="avatar-title"><i class="bx bx-calendar-week font-size-24"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-6">
              <div class="card mini-stats-wid border-0 shadow-sm">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1" style="font-size:12px;">All Time</p>
                      <h4 class="mb-0">{{ myStats.totalCount || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-success bg-gradient">
                      <span class="avatar-title"><i class="bx bx-check-shield font-size-24"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-6">
              <div class="card mini-stats-wid border-0 shadow-sm">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1" style="font-size:12px;">GPS Status</p>
                      <h4 class="mb-0" :class="gps.lat ? 'text-success' : 'text-danger'" style="font-size:14px;">
                        {{ gps.lat ? '📍 Locked' : '⏳ Waiting...' }}
                      </h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle" :class="gps.lat ? 'bg-success' : 'bg-warning'" style="background:transparent;">
                      <span class="avatar-title" :class="gps.lat ? 'bg-success' : 'bg-warning'"><i class="bx bx-map font-size-24"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-body">

                  <!-- Tab Navigation -->
                  <ul class="nav nav-tabs nav-tabs-custom mb-4" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'scan' }" @click="activeTab = 'scan'" href="javascript:void(0);">
                        <i class="bx bx-qr-scan me-1"></i> Scan & Verify
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'unregistered' }" @click="switchToUnregistered" href="javascript:void(0);">
                        <i class="bx bx-plus-circle me-1"></i> Report Unregistered
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'invoice' }" @click="activeTab = 'invoice'" href="javascript:void(0);">
                        <i class="bx bx-receipt me-1"></i> Look Up Invoice
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'history' }" @click="activeTab = 'history'; loadMyInspections()" href="javascript:void(0);">
                        <i class="bx bx-history me-1"></i> My Inspections
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'reports' }" @click="activeTab = 'reports'; loadAllInspections()" href="javascript:void(0);">
                        <i class="bx bx-bar-chart me-1"></i> Reports
                      </a>
                    </li>
                  </ul>

                  <!-- ==================== TAB: SCAN & VERIFY ==================== -->
                  <div v-show="activeTab === 'scan'">

                    <!-- Search / Scan -->
                    <div v-if="!businessLoaded" class="scan-landing">
                      <div class="row justify-content-center">
                        <div class="col-lg-6">
                          <!-- Hero icon -->
                          <div class="scan-hero-icon">
                            <i class="bx bx-qr-scan"></i>
                          </div>
                          <h4 class="scan-title">Scan QR Code or Enter Business ID</h4>
                          <p class="scan-subtitle">Point your camera at the business permit QR code, or type the Business ID manually</p>

                          <div v-if="showScanner" class="mb-3">
                            <video ref="scannerVideo" class="scanner-video" autoplay playsinline muted webkit-playsinline></video>
                            <button class="btn btn-sm btn-outline-danger mt-2" @click="stopScanner"><i class="bx bx-x"></i> Close Camera</button>
                          </div>

                          <div v-if="!showScanner" class="mb-4">
                            <button class="scan-btn" @click="startScanner">
                              <div class="scan-btn-icon"><i class="bx bx-qr-scan"></i></div>
                              <div class="scan-btn-text">
                                <strong>Open QR Scanner</strong>
                                <small>Use camera to scan permit code</small>
                              </div>
                              <i class="bx bx-chevron-right scan-btn-arrow"></i>
                            </button>
                          </div>

                          <div class="divider-text"><span>or enter manually</span></div>

                          <div class="search-input-wrap">
                            <i class="bx bx-search search-input-icon"></i>
                            <input type="text" class="search-input" v-model="searchBusinessID" placeholder="Enter Business ID..." @keyup.enter="fetchBusiness">
                            <button class="search-input-btn" @click="fetchBusiness" :disabled="fetchingBusiness">
                              <span v-if="fetchingBusiness" class="spinner-border spinner-border-sm"></span>
                              <span v-else>Search</span>
                            </button>
                          </div>
                          <div v-if="searchError" class="alert alert-danger mt-3" style="border-radius:12px;">{{ searchError }}</div>

                          <!-- Invoice an unregistered business — separate path from scanning -->
                          <div class="divider-text mt-4"><span>or, found a business with no permit?</span></div>

                          <button class="scan-btn invoice-btn" @click="goInvoiceBusiness()">
                            <div class="scan-btn-icon"><i class="bx bx-receipt"></i></div>
                            <div class="scan-btn-text">
                              <strong>Invoice Business</strong>
                              <small>Register the business and issue an SBP invoice on the spot</small>
                            </div>
                            <i class="bx bx-chevron-right scan-btn-arrow"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Business Found - Verification Form -->
                    <div v-if="businessLoaded">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <button class="btn btn-sm btn-outline-secondary" @click="resetForm"><i class="bx bx-arrow-back me-1"></i> Back to Scanner</button>
                        <span class="badge" :class="business.permitValid ? 'bg-success' : 'bg-danger'" style="font-size:13px;">
                          {{ business.permitValid ? '✓ VALID PERMIT' : '✗ NO VALID PERMIT' }}
                        </span>
                      </div>

                      <!-- Business Details Card -->
                      <div class="card border mb-3">
                        <div class="card-header bg-light py-2"><h6 class="mb-0"><i class="bx bx-store me-1"></i> Business Details (System Record)</h6></div>
                        <div class="card-body p-2">
                          <div class="row g-2" style="font-size:13px;">
                            <div class="col-6"><strong>Business ID:</strong> {{ business.data.businessID }}</div>
                            <div class="col-6"><strong>Name:</strong> {{ business.data.businessName }}</div>
                            <div class="col-6"><strong>Category:</strong> {{ business.data.businessSubCategory || business.data.businessCategory }}</div>
                            <div class="col-6"><strong>Owner:</strong> {{ business.data.fullNames }}</div>
                            <div class="col-6"><strong>Location:</strong> {{ business.data.subCountyName }}, {{ business.data.wardName }}</div>
                            <div class="col-6"><strong>Address:</strong> {{ business.data.physicalAddress || business.data.buildingName || 'N/A' }}</div>
                            <div class="col-6"><strong>Employees:</strong> {{ business.data.numberOfEmployees || 'N/A' }}</div>
                            <div class="col-6"><strong>Premise Size:</strong> {{ business.data.premiseSize || 'N/A' }}</div>
                            <div class="col-12" v-if="business.permit"><strong>Permit Valid:</strong> {{ business.permit.startDate }} to {{ business.permit.endDate }}</div>
                          </div>
                        </div>
                      </div>

                      <!-- Quick actions on the loaded business -->
                      <div class="d-flex flex-wrap gap-2 mb-3">
                        <button v-if="business.permit && business.permit.billNo"
                                class="btn btn-sm btn-outline-primary"
                                @click="viewPermit()">
                          <i class="bx bx-printer me-1"></i> View Permit
                        </button>
                        <button v-if="business.permit && business.permit.billNo"
                                class="btn btn-sm btn-outline-info"
                                @click="viewInvoiceForLoadedBusiness()"
                                title="See exactly what items this business was charged for on the current invoice">
                          <i class="bx bx-receipt me-1"></i> View Invoice
                        </button>
                        <button v-if="business.permit && business.permit.billNo"
                                class="btn btn-sm btn-outline-warning"
                                @click="openTopUpForLoadedBusiness()"
                                title="Issue an additional invoice if the business was undercharged or wrong category">
                          <i class="bx bx-plus-circle me-1"></i> Top Up Business
                        </button>
                      </div>

                      <!-- Duplicate Warning - Inspected Today -->
                      <div v-if="business.inspectedToday" class="alert alert-danger py-3 mb-3" style="border-left:4px solid #dc3545;">
                        <div class="d-flex align-items-start">
                          <i class="bx bx-error-circle me-2" style="font-size:24px;margin-top:2px;"></i>
                          <div>
                            <strong>Already Inspected Today!</strong>
                            <p class="mb-1" style="font-size:13px;">This business has been inspected <strong>{{ business.todayCount }} time(s)</strong> today.</p>
                            <div v-if="business.lastInspection" style="font-size:12px;" class="text-muted">
                              Last: {{ formatTime(business.lastInspection.dateCreated) }} by {{ business.lastInspection.officerNames }}
                              — <span class="badge" :class="verdictBadge(business.lastInspection.verdict)" style="font-size:10px;">{{ business.lastInspection.verdict }}</span>
                            </div>
                            <div class="mt-2">
                              <button class="btn btn-sm btn-outline-danger me-2" @click="duplicateConfirmed = true" v-if="!duplicateConfirmed">
                                <i class="bx bx-check me-1"></i> Inspect Again Anyway
                              </button>
                              <span v-if="duplicateConfirmed" class="text-success" style="font-size:13px;"><i class="bx bx-check-circle me-1"></i> Confirmed — proceed below</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Previous Inspection (not today) -->
                      <div v-else-if="business.lastInspection" class="alert alert-info py-2 mb-3" style="font-size:13px;">
                        <i class="bx bx-info-circle me-1"></i>
                        <strong>Previously inspected:</strong> {{ formatDate(business.lastInspection.dateCreated) }} by {{ business.lastInspection.officerNames }}
                        — <span class="badge" :class="verdictBadge(business.lastInspection.verdict)" style="font-size:10px;">{{ business.lastInspection.verdict }}</span>
                        ({{ business.inspectionCount }} total inspections)
                      </div>

                      <!-- FORM SECTIONS: Hidden if duplicate detected and not confirmed -->
                      <div v-show="!business.inspectedToday || duplicateConfirmed">

                        <!-- VERIFICATION CHECKLIST -->
                        <div class="card border mb-3">
                          <div class="card-header bg-primary text-white py-2"><h6 class="mb-0 text-white"><i class="bx bx-check-double me-1"></i> Verification Checklist</h6></div>
                          <div class="card-body p-3">

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4"><label class="mb-0 fw-bold">Permit Displayed?</label></div>
                              <div class="col-md-8">
                                <div class="btn-group w-100"><button v-for="opt in ['YES','NO','FAKE']" :key="opt" class="btn btn-sm" :class="form.permitDisplayed === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.permitDisplayed = opt">{{ opt }}</button></div>
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4"><label class="mb-0 fw-bold">Permit Matches System?</label></div>
                              <div class="col-md-8">
                                <div class="btn-group w-100"><button v-for="opt in ['YES','NO','N/A']" :key="opt" class="btn btn-sm" :class="form.permitMatches === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.permitMatches = opt">{{ opt }}</button></div>
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4">
                                <label class="mb-0 fw-bold">Business Name</label>
                                <small class="d-block text-muted">System: {{ business.data.businessName }}</small>
                              </div>
                              <div class="col-md-4">
                                <div class="btn-group w-100"><button v-for="opt in ['MATCH','MISMATCH']" :key="opt" class="btn btn-sm" :class="form.businessNameMatch === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.businessNameMatch = opt">{{ opt }}</button></div>
                              </div>
                              <div class="col-md-4">
                                <input v-if="form.businessNameMatch === 'MISMATCH'" type="text" class="form-control form-control-sm" v-model="form.businessNameObserved" placeholder="Name on ground">
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4">
                                <label class="mb-0 fw-bold">Business Category</label>
                                <small class="d-block text-muted">System: {{ business.data.businessSubCategory }}</small>
                              </div>
                              <div class="col-md-4">
                                <div class="btn-group w-100"><button v-for="opt in ['MATCH','MISMATCH']" :key="opt" class="btn btn-sm" :class="form.categoryMatch === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.categoryMatch = opt">{{ opt }}</button></div>
                              </div>
                              <div class="col-md-4">
                                <input v-if="form.categoryMatch === 'MISMATCH'" type="text" class="form-control form-control-sm" v-model="form.categoryObserved" placeholder="Actual activity">
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4">
                                <label class="mb-0 fw-bold">Employee Count</label>
                                <small class="d-block text-muted">System: {{ business.data.numberOfEmployees || 'N/A' }}</small>
                              </div>
                              <div class="col-md-8">
                                <input type="number" class="form-control form-control-sm" v-model="form.employeeCountObserved" placeholder="Observed count" min="0">
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4">
                                <label class="mb-0 fw-bold">Premise Size</label>
                                <small class="d-block text-muted">System: {{ business.data.premiseSize || 'N/A' }}</small>
                              </div>
                              <div class="col-md-4">
                                <div class="btn-group w-100"><button v-for="opt in ['MATCH','MISMATCH']" :key="opt" class="btn btn-sm" :class="form.premiseSizeMatch === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.premiseSizeMatch = opt">{{ opt }}</button></div>
                              </div>
                              <div class="col-md-4">
                                <input v-if="form.premiseSizeMatch === 'MISMATCH'" type="text" class="form-control form-control-sm" v-model="form.premiseSizeObserved" placeholder="Actual size">
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4">
                                <label class="mb-0 fw-bold">Owner</label>
                                <small class="d-block text-muted">System: {{ business.data.fullNames || 'N/A' }}</small>
                              </div>
                              <div class="col-md-4">
                                <div class="btn-group w-100"><button v-for="opt in ['MATCH','MISMATCH']" :key="opt" class="btn btn-sm" :class="form.ownerMatch === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.ownerMatch = opt">{{ opt }}</button></div>
                              </div>
                              <div class="col-md-4">
                                <input v-if="form.ownerMatch === 'MISMATCH'" type="text" class="form-control form-control-sm" v-model="form.ownerObserved" placeholder="Actual owner">
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4">
                                <label class="mb-0 fw-bold">Physical Address</label>
                                <small class="d-block text-muted">System: {{ business.data.physicalAddress || 'N/A' }}</small>
                              </div>
                              <div class="col-md-4">
                                <div class="btn-group w-100"><button v-for="opt in ['MATCH','MISMATCH']" :key="opt" class="btn btn-sm" :class="form.addressMatch === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.addressMatch = opt">{{ opt }}</button></div>
                              </div>
                              <div class="col-md-4">
                                <input v-if="form.addressMatch === 'MISMATCH'" type="text" class="form-control form-control-sm" v-model="form.addressObserved" placeholder="Actual address">
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center border-bottom pb-2">
                              <div class="col-md-4"><label class="mb-0 fw-bold">Fire Licence Displayed?</label></div>
                              <div class="col-md-8">
                                <div class="btn-group w-100"><button v-for="opt in ['YES','NO','N/A']" :key="opt" class="btn btn-sm" :class="form.fireLicenceDisplayed === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.fireLicenceDisplayed = opt">{{ opt }}</button></div>
                              </div>
                            </div>

                            <div class="row mb-3 align-items-center">
                              <div class="col-md-4"><label class="mb-0 fw-bold">Liquor Licence Displayed?</label></div>
                              <div class="col-md-8">
                                <div class="btn-group w-100"><button v-for="opt in ['YES','NO','N/A']" :key="opt" class="btn btn-sm" :class="form.liquorLicenceDisplayed === opt ? 'btn-primary' : 'btn-outline-secondary'" @click="form.liquorLicenceDisplayed = opt">{{ opt }}</button></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- GPS & Map -->
                        <div class="card border mb-3">
                          <div class="card-header bg-light py-2"><h6 class="mb-0"><i class="bx bx-map me-1"></i> Location (GPS)</h6></div>
                          <div class="card-body">
                            <div v-if="gps.lat" style="font-size:13px;" class="mb-2">
                              <span class="text-success fw-bold"><i class="bx bx-check-circle me-1"></i>GPS Locked</span>
                              <span class="text-muted ms-2">{{ Number(gps.lat).toFixed(5) }}, {{ Number(gps.lng).toFixed(5) }} (±{{ gps.accuracy }}m)</span>
                              <div v-if="gps.address" class="text-muted mt-1" style="font-size:12px;"><i class="bx bx-map-pin me-1"></i>{{ gps.address }}</div>
                            </div>
                            <div v-else class="text-warning mb-2" style="font-size:13px;">
                              <i class="bx bx-loader-circle bx-spin me-1"></i> Acquiring GPS...
                              <button class="btn btn-sm btn-outline-primary ms-2" @click="captureGPS"><i class="bx bx-refresh"></i> Retry</button>
                            </div>
                            <button v-if="!showEnforcementMap && gps.lat" class="btn btn-sm btn-outline-primary" @click="toggleMap('enforcement')">
                              <i class="bx bx-map me-1"></i> View Map
                            </button>
                            <button v-if="showEnforcementMap" class="btn btn-sm btn-outline-secondary mb-2" @click="toggleMap('enforcement')">
                              <i class="bx bx-x me-1"></i> Hide Map
                            </button>
                            <div v-if="showEnforcementMap" style="overflow:hidden;border-radius:8px;">
                              <div id="enforcementMap" style="height:200px;width:100%;position:relative;z-index:1;"></div>
                            </div>
                          </div>
                        </div>

                        <!-- Photos -->
                        <div class="card border mb-3">
                          <div class="card-header bg-light py-2"><h6 class="mb-0"><i class="bx bx-camera me-1"></i> Photos (required)</h6></div>
                          <div class="card-body">
                            <div class="d-flex flex-wrap gap-2 mb-2">
                              <div v-for="(photo, idx) in photos" :key="'p-'+idx" class="position-relative" style="width:100px;height:100px;">
                                <img :src="photo.preview" class="rounded-3" style="width:100%;height:100%;object-fit:cover;border:2px solid #eaeaea;">
                                <button class="btn btn-sm btn-danger position-absolute" style="top:2px;right:2px;padding:0 5px;font-size:11px;line-height:20px;" @click="removePhoto(idx)">✕</button>
                                <span class="position-absolute badge bg-dark" style="bottom:2px;left:2px;font-size:9px;">{{ formatFileSize(photo.size) }}</span>
                              </div>
                              <!-- Take Photo Button (camera) -->
                              <label v-if="photos.length < 5 && !compressing" class="photo-capture-btn">
                                <i class="bx bx-camera" style="font-size:28px;"></i>
                                <span style="font-size:10px;">Take Photo</span>
                                <input type="file" accept="image/*" capture="environment" class="d-none" @change="handlePhotoCapture">
                              </label>
                              <!-- Gallery Button -->
                              <label v-if="photos.length < 5 && !compressing" class="photo-capture-btn">
                                <i class="bx bx-images" style="font-size:28px;"></i>
                                <span style="font-size:10px;">Gallery</span>
                                <input type="file" accept="image/*" multiple class="d-none" @change="handlePhotoGallery">
                              </label>
                              <div v-if="compressing" class="photo-capture-btn" style="border-style:solid;border-color:#e0e0e0;">
                                <div class="spinner-border spinner-border-sm text-primary"></div>
                                <span style="font-size:10px;" class="text-muted mt-1">Compressing...</span>
                              </div>
                            </div>
                            <small class="text-muted">Take clear photos of the premises, permit display, and signage. Up to 5 photos, auto-compressed.</small>
                          </div>
                        </div>

                        <!-- Verdict & Remarks -->
                        <div class="card border mb-3">
                          <div class="card-header bg-warning py-2"><h6 class="mb-0"><i class="bx bx-gavel me-1"></i> Verdict</h6></div>
                          <div class="card-body">
                            <div class="row g-2 mb-3">
                              <div class="col-6 col-md-4 col-lg-2" v-for="v in verdictOptions" :key="v.value">
                                <button class="btn btn-sm w-100" :class="form.verdict === v.value ? v.activeClass : 'btn-outline-secondary'" @click="form.verdict = v.value">{{ v.label }}</button>
                              </div>
                            </div>
                            <div class="mb-3">
                              <label class="form-label fw-bold">Remarks</label>
                              <textarea class="form-control" v-model="form.remarks" rows="3" placeholder="Additional observations, issues found, recommendations..."></textarea>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="form.followUpRequired" true-value="YES" false-value="NO" id="followUp">
                                  <label class="form-check-label" for="followUp">Follow-up required</label>
                                </div>
                              </div>
                              <div class="col-md-6" v-if="form.followUpRequired === 'YES'">
                                <input type="date" class="form-control form-control-sm" v-model="form.followUpDate">
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Submit -->
                        <div class="d-grid gap-2 mb-4">
                          <button class="btn btn-success btn-lg" @click="submitInspection" :disabled="submitting || !form.verdict || photos.length === 0">
                            <span v-if="submitting" class="spinner-border spinner-border-sm me-2"></span>
                            <i v-else class="bx bx-check-circle me-2"></i>
                            {{ submitting ? 'Submitting...' : 'Submit Inspection' }}
                          </button>
                        </div>

                      </div><!-- END: duplicate gate wrapper -->
                    </div>
                  </div>

                  <!-- ==================== TAB: REPORT UNREGISTERED ==================== -->
                  <div v-show="activeTab === 'unregistered'">
                    <div class="row justify-content-center">
                      <div class="col-lg-8">
                        <div class="alert alert-warning mb-3">
                          <i class="bx bx-info-circle me-1"></i> Use this form when you find a business operating <strong>without any permit</strong>.
                        </div>

                        <div class="row g-3">
                          <div class="col-12">
                            <label class="form-label fw-bold">Business Name (as seen on site) <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="unreg.businessName" placeholder="Name of the business">
                          </div>
                          <div class="col-12">
                            <label class="form-label fw-bold">Business Activity</label>
                            <input type="text" class="form-control" v-model="unreg.businessActivity" placeholder="What does the business do?">
                          </div>
                          <div class="col-md-6">
                            <label class="form-label fw-bold">Owner Name</label>
                            <input type="text" class="form-control" v-model="unreg.ownerName" placeholder="If known">
                          </div>
                          <div class="col-md-6">
                            <label class="form-label fw-bold">Owner Phone</label>
                            <input type="text" class="form-control" v-model="unreg.ownerPhone" placeholder="If known">
                          </div>
                          <div class="col-12">
                            <label class="form-label fw-bold">Physical Address</label>
                            <input type="text" class="form-control" v-model="unreg.physicalAddress" placeholder="Building, street, landmarks">
                          </div>
                          <div class="col-md-6">
                            <label class="form-label fw-bold">Sub County</label>
                            <input type="text" class="form-control" v-model="unreg.subCountyName" placeholder="Sub county">
                          </div>
                          <div class="col-md-6">
                            <label class="form-label fw-bold">Ward</label>
                            <input type="text" class="form-control" v-model="unreg.wardName" placeholder="Ward">
                          </div>

                          <!-- GPS & Map for Unregistered -->
                          <div class="col-12">
                            <div class="card border mb-0">
                              <div class="card-header bg-light py-2"><h6 class="mb-0"><i class="bx bx-map me-1"></i> Location (GPS)</h6></div>
                              <div class="card-body">
                                <div v-if="gps.lat" style="font-size:13px;" class="mb-2">
                                  <span class="text-success fw-bold"><i class="bx bx-check-circle me-1"></i>GPS Locked</span>
                                  <span class="text-muted ms-2">{{ Number(gps.lat).toFixed(5) }}, {{ Number(gps.lng).toFixed(5) }}</span>
                                  <div v-if="gps.address" class="text-muted mt-1" style="font-size:12px;"><i class="bx bx-map-pin me-1"></i>{{ gps.address }}</div>
                                </div>
                                <div v-else class="text-warning mb-2" style="font-size:13px;">
                                  <i class="bx bx-loader-circle bx-spin me-1"></i> Acquiring GPS...
                                  <button class="btn btn-sm btn-outline-primary ms-2" @click="captureGPS"><i class="bx bx-refresh"></i> Retry</button>
                                </div>
                                <button v-if="!showUnregMap && gps.lat" class="btn btn-sm btn-outline-primary" @click="toggleMap('unreg')">
                                  <i class="bx bx-map me-1"></i> View Map
                                </button>
                                <button v-if="showUnregMap" class="btn btn-sm btn-outline-secondary mb-2" @click="toggleMap('unreg')">
                                  <i class="bx bx-x me-1"></i> Hide Map
                                </button>
                                <div v-if="showUnregMap" style="overflow:hidden;border-radius:8px;">
                                  <div id="unregMap" style="height:200px;width:100%;position:relative;z-index:1;"></div>
                                </div>
                                <small class="text-muted d-block mt-1">Tap the map to adjust the pin if needed</small>
                              </div>
                            </div>
                          </div>

                          <div class="col-12">
                            <label class="form-label fw-bold">Remarks</label>
                            <textarea class="form-control" v-model="unreg.remarks" rows="2" placeholder="Any additional notes"></textarea>
                          </div>

                          <!-- Photos for Unregistered -->
                          <div class="col-12">
                            <label class="form-label fw-bold">Photos</label>
                            <div class="d-flex flex-wrap gap-2 mb-2">
                              <div v-for="(photo, idx) in unregPhotos" :key="'up-'+idx" class="position-relative" style="width:100px;height:100px;">
                                <img :src="photo.preview" class="rounded-3" style="width:100%;height:100%;object-fit:cover;border:2px solid #eaeaea;">
                                <button class="btn btn-sm btn-danger position-absolute" style="top:2px;right:2px;padding:0 5px;font-size:11px;line-height:20px;" @click="unregPhotos.splice(idx, 1)">✕</button>
                                <span class="position-absolute badge bg-dark" style="bottom:2px;left:2px;font-size:9px;">{{ formatFileSize(photo.size) }}</span>
                              </div>
                              <label v-if="unregPhotos.length < 5 && !compressing" class="photo-capture-btn">
                                <i class="bx bx-camera" style="font-size:28px;"></i>
                                <span style="font-size:10px;">Take Photo</span>
                                <input type="file" accept="image/*" capture="environment" class="d-none" @change="handleUnregPhotoCapture">
                              </label>
                              <label v-if="unregPhotos.length < 5 && !compressing" class="photo-capture-btn">
                                <i class="bx bx-images" style="font-size:28px;"></i>
                                <span style="font-size:10px;">Gallery</span>
                                <input type="file" accept="image/*" multiple class="d-none" @change="handleUnregPhotoGallery">
                              </label>
                              <div v-if="compressing" class="photo-capture-btn" style="border-style:solid;border-color:#e0e0e0;">
                                <div class="spinner-border spinner-border-sm text-primary"></div>
                                <span style="font-size:10px;" class="text-muted mt-1">Compressing...</span>
                              </div>
                            </div>
                          </div>

                          <div class="col-12">
                            <button class="btn btn-danger btn-lg w-100" @click="submitUnregistered" :disabled="submitting || !unreg.businessName">
                              <span v-if="submitting" class="spinner-border spinner-border-sm me-2"></span>
                              <i v-else class="bx bx-error-circle me-2"></i>
                              {{ submitting ? 'Submitting...' : 'Report Unregistered Business' }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- ==================== TAB: INVOICE LOOKUP ==================== -->
                  <div v-show="activeTab === 'invoice'">

                    <div class="row justify-content-center">
                      <div class="col-lg-8">

                        <!-- Search bar -->
                        <div class="card border shadow-sm mb-3">
                          <div class="card-body">
                            <label class="form-label mb-1"><strong>Invoice Number</strong></label>
                            <div class="input-group">
                              <input type="text"
                                     class="form-control"
                                     v-model.trim="invoice.searchBillNo"
                                     placeholder="e.g. BLL0420021628732"
                                     @keyup.enter="searchInvoice"
                                     :disabled="invoice.loading">
                              <button class="btn btn-primary" type="button"
                                      @click="searchInvoice"
                                      :disabled="invoice.loading || !invoice.searchBillNo">
                                <i class="bx bx-search me-1"></i>
                                <span v-if="invoice.loading">Searching…</span>
                                <span v-else>Look Up</span>
                              </button>
                            </div>
                            <small class="text-muted">Type the bill number exactly as it appears on the invoice or paybill prompt.</small>
                          </div>
                        </div>

                        <!-- Error -->
                        <div v-if="invoice.error" class="alert alert-warning d-flex align-items-center mb-3">
                          <i class="bx bx-info-circle me-2 fs-4"></i>
                          <div>{{ invoice.error }}</div>
                        </div>

                        <!-- Result: bill summary + line items -->
                        <div v-if="invoice.billDetails" class="card border shadow-sm">
                          <div class="card-body">

                            <!-- Header summary -->
                            <div class="d-flex justify-content-between align-items-start mb-3">
                              <div>
                                <h5 class="mb-1">{{ invoice.billDetails.billNo }}</h5>
                                <small class="text-muted">{{ formatInvoiceDate(invoice.billDetails.dateCreated) }}</small>
                              </div>
                              <span class="badge fs-6"
                                    :class="invoiceStatusBadge(invoice.billDetails.status)">
                                {{ invoice.billDetails.status || 'UNPAID' }}
                              </span>
                            </div>

                            <!-- Customer / payer info -->
                            <div class="row mb-3 g-3">
                              <div class="col-md-6">
                                <div class="text-muted small">Customer</div>
                                <div>{{ invoice.billDetails.customerName || invoice.billDetails.names || '—' }}</div>
                              </div>
                              <div class="col-md-6">
                                <div class="text-muted small">Phone</div>
                                <div>{{ invoice.billDetails.customerPhoneNumber || '—' }}</div>
                              </div>
                              <div class="col-md-6">
                                <div class="text-muted small">Department</div>
                                <div>{{ invoice.billDetails.department || invoice.billDetails.incomeTypeDescription || '—' }}</div>
                              </div>
                              <div class="col-md-6">
                                <div class="text-muted small">Sub-County / Ward</div>
                                <div>{{ invoice.billDetails.subCountyName || '—' }}<span v-if="invoice.billDetails.wardName"> / {{ invoice.billDetails.wardName }}</span></div>
                              </div>
                            </div>

                            <!-- Totals strip -->
                            <div class="row text-center g-2 mb-3">
                              <div class="col-4">
                                <div class="border rounded py-2">
                                  <div class="text-muted small">Total</div>
                                  <div class="fw-bold">KES {{ formatMoney(invoice.billDetails.detailAmount) }}</div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="border rounded py-2">
                                  <div class="text-muted small">Paid</div>
                                  <div class="fw-bold text-success">KES {{ formatMoney(invoice.billDetails.receiptAmount) }}</div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="border rounded py-2">
                                  <div class="text-muted small">Balance</div>
                                  <div class="fw-bold" :class="parseFloat(invoice.billDetails.billBalance) > 0 ? 'text-danger' : 'text-success'">
                                    KES {{ formatMoney(invoice.billDetails.billBalance) }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Line items -->
                            <h6 class="mt-3 mb-2">Line Items</h6>
                            <div class="table-responsive">
                              <table class="table table-sm table-bordered mb-0">
                                <thead class="table-light">
                                <tr>
                                  <th style="width:30px;">#</th>
                                  <th>Fee</th>
                                  <th class="text-end">Amount</th>
                                  <th class="text-end">Paid</th>
                                  <th class="text-end">Balance</th>
                                  <th>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(line, idx) in invoice.billInfo" :key="'inv-' + idx">
                                  <td>{{ idx + 1 }}</td>
                                  <td>
                                    <div>{{ line.feeDescription || line.description || '—' }}</div>
                                    <small v-if="line.customer" class="text-muted">{{ line.customer }}</small>
                                  </td>
                                  <td class="text-end">{{ formatMoney(line.billTotal) }}</td>
                                  <td class="text-end">{{ formatMoney(line.receiptAmount) }}</td>
                                  <td class="text-end">{{ formatMoney(line.billBalance) }}</td>
                                  <td>
                                    <span class="badge" :class="invoiceStatusBadge(line.status)">{{ line.status || 'UNPAID' }}</span>
                                  </td>
                                </tr>
                                <tr v-if="!invoice.billInfo || !invoice.billInfo.length">
                                  <td colspan="6" class="text-center text-muted py-3">No line items recorded for this bill.</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>

                            <!-- Send Payment Prompt — visible only when there's still a balance -->
                            <div v-if="parseFloat(invoice.billDetails.billBalance) > 0" class="mt-4 pt-3 border-top">
                              <h6 class="mb-2"><i class="bx bx-mobile-alt text-success me-1"></i> Send Payment Prompt</h6>
                              <p class="text-muted small mb-2">
                                The customer will receive an M-PESA STK push (or SMS link) to pay
                                <strong>KES {{ formatMoney(invoice.billDetails.billBalance) }}</strong>
                                for invoice <code>{{ invoice.billDetails.billNo }}</code>.
                              </p>
                              <div class="row g-2 align-items-end">
                                <div class="col-12 col-md-6">
                                  <label class="form-label small mb-1">Customer Phone</label>
                                  <input type="tel"
                                         class="form-control"
                                         placeholder="2547XXXXXXXX"
                                         v-model.trim="invoicePayment.phoneNumber">
                                </div>
                                <div class="col-12 col-md-6">
                                  <button class="btn btn-success w-100"
                                          @click="sendInvoicePaymentPrompt"
                                          :disabled="invoicePayment.sending || !invoicePayment.phoneNumber">
                                    <span v-if="invoicePayment.sending">
                                      <span class="spinner-border spinner-border-sm me-1"></span>Sending…
                                    </span>
                                    <span v-else>
                                      <i class="bx bx-send me-1"></i> Send Payment Prompt
                                    </span>
                                  </button>
                                </div>
                              </div>
                              <div v-if="invoicePayment.message" class="alert mt-2 mb-0 py-2" :class="invoicePayment.success ? 'alert-success' : 'alert-warning'">
                                <i class="bx me-1" :class="invoicePayment.success ? 'bx-check-circle' : 'bx-info-circle'"></i>
                                {{ invoicePayment.message }}
                              </div>
                            </div>

                            <!-- Already-paid badge -->
                            <div v-else class="mt-3 alert alert-success mb-0 py-2">
                              <i class="bx bx-check-circle me-1"></i> This invoice is fully paid.
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <!-- ==================== TAB: MY INSPECTIONS ==================== -->
                  <div v-show="activeTab === 'history'">

                    <!-- Header with view toggle -->
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <h6 class="mb-0">Today's Inspections <span class="badge bg-primary ms-1">{{ myInspections.length }}</span></h6>
                      </div>
                      <div class="btn-group btn-group-sm">
                        <button class="btn" :class="myView === 'grid' ? 'btn-primary' : 'btn-outline-secondary'" @click="myView = 'grid'" title="Card View">
                          <i class="bx bx-grid-alt"></i>
                        </button>
                        <button class="btn" :class="myView === 'list' ? 'btn-primary' : 'btn-outline-secondary'" @click="myView = 'list'" title="List View">
                          <i class="bx bx-list-ul"></i>
                        </button>
                      </div>
                    </div>

                    <!-- Grid View -->
                    <div v-if="myView === 'grid'" class="row g-3">
                      <div class="col-md-6 col-lg-4" v-for="(ins) in myInspections" :key="'mg-'+ins.inspectionID">
                        <div class="card border h-100 mb-0 shadow-sm inspection-card" @click="openDetail(ins)" style="cursor:pointer;">
                          <div v-if="getPhotoUrls(ins.photos).length > 0" class="d-flex" style="height:120px;overflow:hidden;border-radius:14px 14px 0 0;">
                            <img v-for="(url, pi) in getPhotoUrls(ins.photos).slice(0, 3)" :key="pi"
                                 :src="url" :style="'flex:1;object-fit:cover;' + (pi > 0 ? 'border-left:2px solid #fff;' : '')">
                          </div>
                          <div v-else style="height:50px;background:linear-gradient(135deg,#f8f9fe,#eef0fb);display:flex;align-items:center;justify-content:center;border-radius:14px 14px 0 0;">
                            <span class="text-muted" style="font-size:12px;"><i class="bx bx-camera-off me-1"></i>No photos</span>
                          </div>
                          <div class="card-body p-3">
                            <div class="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                <h6 class="mb-0" style="font-size:14px;">{{ ins.businessName || 'Unregistered' }}</h6>
                                <small class="text-muted">{{ ins.businessID || 'No ID' }} · {{ formatTime(ins.dateCreated) }}</small>
                              </div>
                              <span class="badge" :class="verdictBadge(ins.verdict)">{{ ins.verdict }}</span>
                            </div>
                            <div style="font-size:12px;color:#8c8c8c;">
                              <span class="me-3"><i class="bx bx-category me-1"></i>{{ ins.inspectionType }}</span>
                              <span class="me-3"><i class="bx bx-camera me-1"></i>{{ photoCount(ins.photos) }}</span>
                              <div v-if="ins.latitude" class="text-success mt-1" style="font-size:11px;">
                                <i class="bx bx-map me-1"></i>{{ ins.locationAddress || (Number(ins.latitude).toFixed(4) + ', ' + Number(ins.longitude).toFixed(4)) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="!myInspections.length" class="col-12">
                        <div class="text-center py-5">
                          <div class="scan-hero-icon" style="width:60px;height:60px;margin:0 auto 16px;animation:none;opacity:0.5;">
                            <i class="bx bx-search-alt" style="font-size:24px;"></i>
                          </div>
                          <h6 class="text-muted">No inspections today</h6>
                          <p class="text-muted" style="font-size:13px;">Start by scanning a QR code or entering a Business ID</p>
                        </div>
                      </div>
                    </div>

                    <!-- List View -->
                    <div v-if="myView === 'list'" class="table-responsive">
                      <table class="table table-sm table-hover align-middle">
                        <thead>
                        <tr><th style="width:30px;">#</th><th>Photo</th><th>Time</th><th>Business</th><th>Type</th><th>Verdict</th><th>Location</th></tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ins, idx) in myInspections" :key="'ml-'+ins.inspectionID" @click="openDetail(ins)" style="cursor:pointer;">
                          <td>{{ idx + 1 }}</td>
                          <td>
                            <div v-if="getPhotoUrls(ins.photos).length > 0" class="d-flex gap-1">
                              <img v-for="(url, pi) in getPhotoUrls(ins.photos).slice(0, 2)" :key="pi"
                                   :src="url" style="width:40px;height:40px;object-fit:cover;border-radius:6px;border:2px solid #eaeaea;">
                              <span v-if="getPhotoUrls(ins.photos).length > 2" class="d-flex align-items-center text-muted" style="font-size:10px;">+{{ getPhotoUrls(ins.photos).length - 2 }}</span>
                            </div>
                            <span v-else class="text-muted" style="font-size:11px;">No photos</span>
                          </td>
                          <td style="white-space:nowrap;">{{ formatTime(ins.dateCreated) }}</td>
                          <td>{{ ins.businessName || 'Unregistered' }}<br><small class="text-muted">{{ ins.businessID }}</small></td>
                          <td><span class="badge bg-secondary">{{ ins.inspectionType }}</span></td>
                          <td><span class="badge" :class="verdictBadge(ins.verdict)">{{ ins.verdict }}</span></td>
                          <td style="font-size:11px;">
                            <div v-if="ins.latitude" class="text-success">
                              <i class="bx bx-map me-1"></i>{{ ins.locationAddress || (Number(ins.latitude).toFixed(4) + ', ' + Number(ins.longitude).toFixed(4)) }}
                            </div>
                            <span v-else class="text-muted">—</span>
                          </td>
                        </tr>
                        <tr v-if="!myInspections.length"><td colspan="7" class="text-center text-muted py-4">No inspections today.</td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- ==================== TAB: REPORTS ==================== -->
                  <div v-show="activeTab === 'reports'">

                    <!-- Sub-toggle: Inspections vs Issued Invoices -->
                    <div class="btn-group btn-group-sm mb-3 w-100" role="group">
                      <button type="button" class="btn"
                              :class="reportSubView === 'inspections' ? 'btn-primary' : 'btn-outline-primary'"
                              @click="reportSubView = 'inspections'">
                        <i class="bx bx-clipboard me-1"></i> Inspections
                      </button>
                      <button type="button" class="btn"
                              :class="reportSubView === 'invoices' ? 'btn-primary' : 'btn-outline-primary'"
                              @click="reportSubView = 'invoices'; loadIssuedInvoices()">
                        <i class="bx bx-receipt me-1"></i> Issued Invoices
                      </button>
                    </div>

                    <!-- ===== ISSUED INVOICES SUB-VIEW ===== -->
                    <div v-show="reportSubView === 'invoices'">
                      <!-- Filters -->
                      <div class="row g-2 mb-3 align-items-center">
                        <div class="col-6 col-md-3">
                          <input type="date" class="form-control form-control-sm" v-model="invoicesReport.dateFrom">
                        </div>
                        <div class="col-6 col-md-3">
                          <input type="date" class="form-control form-control-sm" v-model="invoicesReport.dateTo">
                        </div>
                        <div class="col-12 col-md-3 d-flex align-items-center">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="myInvoicesOnly" v-model="invoicesReport.myOnly">
                            <label class="form-check-label" for="myInvoicesOnly">Only mine</label>
                          </div>
                        </div>
                        <div class="col-12 col-md-3">
                          <button class="btn btn-primary btn-sm w-100" @click="loadIssuedInvoices">
                            <i class="bx bx-filter me-1"></i> Apply
                          </button>
                        </div>
                      </div>

                      <!-- KPI strip -->
                      <div class="row g-2 mb-3">
                        <div class="col-4">
                          <div class="card border text-center p-2 mb-0">
                            <small class="text-muted">Issued</small>
                            <h5 class="mb-0">KES {{ formatMoney(invoicesReport.totalIssued) }}</h5>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="card border text-center p-2 mb-0">
                            <small class="text-success">Paid</small>
                            <h5 class="mb-0 text-success">KES {{ formatMoney(invoicesReport.totalPaid) }}</h5>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="card border text-center p-2 mb-0">
                            <small class="text-danger">Outstanding</small>
                            <h5 class="mb-0 text-danger">KES {{ formatMoney(invoicesReport.totalBalance) }}</h5>
                          </div>
                        </div>
                      </div>

                      <!-- Mobile card list / desktop table -->
                      <div v-if="invoicesReport.loading" class="text-center text-muted py-4">Loading…</div>
                      <div v-else-if="!invoicesReport.rows.length" class="text-center text-muted py-4">No invoices issued in this range.</div>
                      <div v-else>
                        <!-- Card list (phones) -->
                        <div class="d-md-none">
                          <div v-for="row in invoicesReport.rows" :key="'inv-card-'+row.id"
                               class="card border mb-2 shadow-sm"
                               @click="openInvoiceFromReport(row)" style="cursor:pointer;">
                            <div class="card-body p-3">
                              <div class="d-flex justify-content-between align-items-start mb-1">
                                <strong>{{ row.businessName || 'Unregistered' }}</strong>
                                <span class="badge" :class="invoiceStatusBadge(row.billStatus)">{{ row.billStatus || 'UNPAID' }}</span>
                              </div>
                              <div class="text-muted small mb-1">{{ row.billNo }}</div>
                              <div class="d-flex justify-content-between align-items-end">
                                <small class="text-muted">{{ formatInvoiceDate(row.dateCreated) }}</small>
                                <strong>KES {{ formatMoney(row.amount) }}</strong>
                              </div>
                              <div class="text-muted small mt-1" v-if="row.issuedBy">By {{ row.issuedBy }}</div>
                            </div>
                          </div>
                        </div>

                        <!-- Table (tablet/desktop) -->
                        <div class="table-responsive d-none d-md-block">
                          <table class="table table-sm table-hover align-middle">
                          <thead class="table-light">
                          <tr>
                            <th>Date</th>
                            <th>Bill No</th>
                            <th>Business</th>
                            <th>Phone</th>
                            <th class="text-end">Amount</th>
                            <th class="text-end">Paid</th>
                            <th class="text-end">Balance</th>
                            <th>Status</th>
                            <th>Officer</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="row in invoicesReport.rows" :key="'inv-row-'+row.id"
                              @click="openInvoiceFromReport(row)" style="cursor:pointer;">
                            <td>{{ formatInvoiceDate(row.dateCreated) }}</td>
                            <td><code>{{ row.billNo }}</code></td>
                            <td>{{ row.businessName || '—' }}</td>
                            <td>{{ row.customerPhone || '—' }}</td>
                            <td class="text-end">{{ formatMoney(row.amount) }}</td>
                            <td class="text-end">{{ formatMoney(row.paidAmount) }}</td>
                            <td class="text-end">{{ formatMoney(row.balance) }}</td>
                            <td><span class="badge" :class="invoiceStatusBadge(row.billStatus)">{{ row.billStatus || 'UNPAID' }}</span></td>
                            <td>{{ row.issuedBy || '—' }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      </div><!-- /v-else (rows present) -->
                    </div><!-- /reportSubView === 'invoices' -->

                    <!-- ===== INSPECTIONS SUB-VIEW (default) ===== -->
                    <div v-show="reportSubView === 'inspections'">

                    <!-- Filters + View Toggle -->
                    <div class="row g-2 mb-3 align-items-center">
                      <div class="col-md-3"><input type="text" class="form-control form-control-sm" v-model="reportSearch" placeholder="Search..." @keyup.enter="loadAllInspections"></div>
                      <div class="col-md-2"><input type="date" class="form-control form-control-sm" v-model="reportDateFrom"></div>
                      <div class="col-md-2"><input type="date" class="form-control form-control-sm" v-model="reportDateTo"></div>
                      <div class="col-md-2">
                        <select class="form-select form-select-sm" v-model="reportVerdict">
                          <option value="">All Verdicts</option>
                          <option v-for="v in verdictOptions" :value="v.value" :key="v.value">{{ v.label }}</option>
                        </select>
                      </div>
                      <div class="col-md-1"><button class="btn btn-primary btn-sm w-100" @click="loadAllInspections"><i class="bx bx-filter"></i></button></div>
                      <div class="col-md-2 text-end">
                        <div class="btn-group btn-group-sm">
                          <button class="btn" :class="reportView === 'grid' ? 'btn-primary' : 'btn-outline-secondary'" @click="reportView = 'grid'" title="Card View">
                            <i class="bx bx-grid-alt"></i>
                          </button>
                          <button class="btn" :class="reportView === 'list' ? 'btn-primary' : 'btn-outline-secondary'" @click="reportView = 'list'" title="List View">
                            <i class="bx bx-list-ul"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Stats -->
                    <div class="row g-2 mb-3" v-if="reportStats">
                      <div class="col"><div class="card border text-center p-2 mb-0"><small class="text-muted">Total</small><h5 class="mb-0">{{ reportStats.total }}</h5></div></div>
                      <div class="col"><div class="card border text-center p-2 mb-0"><small class="text-success">Compliant</small><h5 class="mb-0 text-success">{{ reportStats.compliant }}</h5></div></div>
                      <div class="col"><div class="card border text-center p-2 mb-0"><small class="text-danger">Non-Compliant</small><h5 class="mb-0 text-danger">{{ reportStats.nonCompliant }}</h5></div></div>
                      <div class="col"><div class="card border text-center p-2 mb-0"><small class="text-warning">No Permit</small><h5 class="mb-0 text-warning">{{ reportStats.noPermit }}</h5></div></div>
                      <div class="col"><div class="card border text-center p-2 mb-0"><small class="text-info">Today</small><h5 class="mb-0 text-info">{{ reportStats.today }}</h5></div></div>
                    </div>

                    <!-- ===== GRID / CARD VIEW ===== -->
                    <div v-if="reportView === 'grid'" class="row g-3">
                      <div class="col-md-6 col-lg-4" v-for="(ins) in allInspections" :key="'g-'+ins.id">
                        <div class="card border h-100 mb-0 shadow-sm inspection-card" @click="openDetail(ins)" style="cursor:pointer;">
                          <!-- Photo strip at top -->
                          <div v-if="getPhotoUrls(ins.photos).length > 0" class="d-flex" style="height:120px;overflow:hidden;border-radius:4px 4px 0 0;">
                            <img v-for="(url, pi) in getPhotoUrls(ins.photos).slice(0, 3)" :key="pi"
                                 :src="url" :style="'flex:1;object-fit:cover;' + (pi > 0 ? 'border-left:2px solid #fff;' : '')">
                          </div>
                          <div v-else style="height:60px;background:#f8f9fa;display:flex;align-items:center;justify-content:center;border-radius:4px 4px 0 0;">
                            <span class="text-muted" style="font-size:12px;"><i class="bx bx-camera-off me-1"></i>No photos</span>
                          </div>
                          <div class="card-body p-3">
                            <!-- Header row -->
                            <div class="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                <h6 class="mb-0" style="font-size:14px;">{{ ins.businessName || 'Unregistered Business' }}</h6>
                                <small class="text-muted">{{ ins.businessID || 'No ID' }}</small>
                              </div>
                              <span class="badge" :class="verdictBadge(ins.verdict)" style="font-size:11px;">{{ ins.verdict }}</span>
                            </div>
                            <!-- Details -->
                            <div style="font-size:12px;color:#6c757d;line-height:1.8;">
                              <div><i class="bx bx-user me-1"></i>{{ ins.officerNames }}</div>
                              <div><i class="bx bx-calendar me-1"></i>{{ formatDate(ins.dateCreated) }} {{ formatTime(ins.dateCreated) }}</div>
                              <div><i class="bx bx-category me-1"></i><span class="badge bg-secondary" style="font-size:10px;">{{ ins.inspectionType }}</span></div>
                              <div v-if="ins.latitude">
                                <i class="bx bx-map text-success me-1"></i>
                                <span class="text-success">{{ ins.locationAddress || (Number(ins.latitude).toFixed(4) + ', ' + Number(ins.longitude).toFixed(4)) }}</span>
                              </div>
                              <!-- Checklist summary -->
                              <div v-if="ins.permitDisplayed" class="mt-1">
                                <span class="me-2">Permit: <strong :class="ins.permitDisplayed === 'YES' ? 'text-success' : 'text-danger'">{{ ins.permitDisplayed }}</strong></span>
                                <span v-if="ins.businessNameMatch" class="me-2">Name: <strong :class="ins.businessNameMatch === 'MATCH' ? 'text-success' : 'text-danger'">{{ ins.businessNameMatch }}</strong></span>
                                <span v-if="ins.categoryMatch">Cat: <strong :class="ins.categoryMatch === 'MATCH' ? 'text-success' : 'text-danger'">{{ ins.categoryMatch }}</strong></span>
                              </div>
                              <div v-if="ins.remarks" class="mt-1 text-dark" style="font-style:italic;">"{{ ins.remarks.substring(0, 80) }}{{ ins.remarks.length > 80 ? '...' : '' }}"</div>
                            </div>
                          </div>
                          <div class="card-footer bg-transparent py-2 d-flex justify-content-between" style="font-size:11px;">
                            <span class="text-muted"><i class="bx bx-camera me-1"></i>{{ photoCount(ins.photos) }} photos</span>
                            <span class="text-muted">{{ ins.inspectionID }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="!allInspections.length" class="col-12 text-center py-5 text-muted">No inspections found</div>
                    </div>

                    <!-- ===== LIST / TABLE VIEW ===== -->
                    <div v-if="reportView === 'list'" class="table-responsive">
                      <table class="table table-sm table-hover table-bordered align-middle" style="font-size:12px;">
                        <thead class="table-light">
                        <tr><th style="width:30px;">#</th><th>Photo</th><th>Date</th><th>Officer</th><th>Business</th><th>Type</th><th>Verdict</th><th>Location</th><th>Checklist</th><th>Remarks</th></tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ins, idx) in allInspections" :key="'l-'+ins.id" @click="openDetail(ins)" style="cursor:pointer;">
                          <td>{{ idx + 1 + ((reportPage - 1) * reportRows) }}</td>
                          <td>
                            <div v-if="getPhotoUrls(ins.photos).length > 0" class="d-flex gap-1">
                              <img v-for="(url, pi) in getPhotoUrls(ins.photos).slice(0, 2)" :key="pi"
                                   :src="url" style="width:36px;height:36px;object-fit:cover;border-radius:4px;border:1px solid #dee2e6;">
                              <span v-if="getPhotoUrls(ins.photos).length > 2" class="d-flex align-items-center text-muted" style="font-size:10px;">+{{ getPhotoUrls(ins.photos).length - 2 }}</span>
                            </div>
                            <span v-else class="text-muted">—</span>
                          </td>
                          <td style="white-space:nowrap;">{{ formatDate(ins.dateCreated) }}<br><small class="text-muted">{{ formatTime(ins.dateCreated) }}</small></td>
                          <td>{{ ins.officerNames }}</td>
                          <td>{{ ins.businessName || 'Unregistered' }}<br><small class="text-muted">{{ ins.businessID }}</small></td>
                          <td><span class="badge bg-secondary">{{ ins.inspectionType }}</span></td>
                          <td><span class="badge" :class="verdictBadge(ins.verdict)">{{ ins.verdict }}</span></td>
                          <td style="font-size:11px;">
                            <span v-if="ins.latitude" class="text-success">📍 {{ ins.locationAddress || (Number(ins.latitude).toFixed(4) + ', ' + Number(ins.longitude).toFixed(4)) }}</span>
                            <span v-else class="text-muted">—</span>
                          </td>
                          <td style="font-size:11px;">
                            <span v-if="ins.permitDisplayed" :class="ins.permitDisplayed === 'YES' ? 'text-success' : 'text-danger'">P:{{ ins.permitDisplayed }}</span>
                            <span v-if="ins.businessNameMatch" class="ms-1" :class="ins.businessNameMatch === 'MATCH' ? 'text-success' : 'text-danger'">N:{{ ins.businessNameMatch === 'MATCH' ? '✓' : '✗' }}</span>
                            <span v-if="ins.categoryMatch" class="ms-1" :class="ins.categoryMatch === 'MATCH' ? 'text-success' : 'text-danger'">C:{{ ins.categoryMatch === 'MATCH' ? '✓' : '✗' }}</span>
                          </td>
                          <td style="max-width:150px;font-size:11px;">{{ ins.remarks ? ins.remarks.substring(0, 60) + (ins.remarks.length > 60 ? '...' : '') : '—' }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Pagination -->
                    <div class="d-flex justify-content-between align-items-center mt-3" v-if="reportTotalItems > reportRows">
                      <small class="text-muted">{{ reportTotalItems }} records</small>
                      <nav>
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: reportPage <= 1 }"><a class="page-link" href="javascript:void(0);" @click="reportPage--; loadAllInspections()">Prev</a></li>
                          <li class="page-item active"><a class="page-link" href="javascript:void(0);">{{ reportPage }}</a></li>
                          <li class="page-item" :class="{ disabled: reportPage * reportRows >= reportTotalItems }"><a class="page-link" href="javascript:void(0);" @click="reportPage++; loadAllInspections()">Next</a></li>
                        </ul>
                      </nav>
                    </div>
                    </div><!-- /reportSubView === 'inspections' -->
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- ==================== INSPECTION DETAIL MODAL ==================== -->
          <div class="modal fade" id="detailModal" tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
              <div class="modal-content" v-if="selectedInspection">
                <div class="modal-header py-2">
                  <div>
                    <h5 class="modal-title mb-0">Inspection Details</h5>
                    <small class="text-muted">{{ selectedInspection.inspectionID }}</small>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge" :class="verdictBadge(selectedInspection.verdict)" style="font-size:13px;">{{ selectedInspection.verdict }}</span>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                  </div>
                </div>
                <div class="modal-body p-0">
                  <div class="row g-0">

                    <!-- LEFT: Photos -->
                    <div class="col-lg-5" style="background:#f8f9fa;overflow:hidden;">
                      <div v-if="getPhotoUrls(selectedInspection.photos).length > 0">
                        <!-- Main Photo -->
                        <div style="position:relative;overflow:hidden;">
                          <img :src="getPhotoUrls(selectedInspection.photos)[activePhotoIndex]"
                               style="width:100%;height:300px;object-fit:cover;display:block;">
                          <div class="position-absolute bottom-0 start-0 end-0 p-2 d-flex justify-content-center gap-1" style="background:linear-gradient(transparent, rgba(0,0,0,0.6));">
                            <span class="badge bg-dark">{{ activePhotoIndex + 1 }} / {{ getPhotoUrls(selectedInspection.photos).length }}</span>
                          </div>
                          <!-- Nav arrows -->
                          <button v-if="activePhotoIndex > 0" class="btn btn-sm btn-dark position-absolute" style="left:8px;top:50%;transform:translateY(-50%);opacity:0.7;" @click.stop="activePhotoIndex--">
                            <i class="bx bx-chevron-left"></i>
                          </button>
                          <button v-if="activePhotoIndex < getPhotoUrls(selectedInspection.photos).length - 1" class="btn btn-sm btn-dark position-absolute" style="right:8px;top:50%;transform:translateY(-50%);opacity:0.7;" @click.stop="activePhotoIndex++">
                            <i class="bx bx-chevron-right"></i>
                          </button>
                        </div>
                        <!-- Thumbnail strip -->
                        <div class="d-flex gap-1 p-2" style="overflow-x:auto;">
                          <img v-for="(url, pi) in getPhotoUrls(selectedInspection.photos)" :key="'dt-'+pi"
                               :src="url" @click.stop="activePhotoIndex = pi"
                               style="width:56px;height:56px;object-fit:cover;border-radius:4px;cursor:pointer;border:2px solid transparent;flex-shrink:0;"
                               :style="pi === activePhotoIndex ? 'border-color:#556ee6;' : 'opacity:0.7;'">
                        </div>
                      </div>
                      <div v-else class="d-flex align-items-center justify-content-center text-muted" style="height:160px;">
                        <div class="text-center"><i class="bx bx-camera-off" style="font-size:40px;"></i><div class="mt-1">No photos captured</div></div>
                      </div>

                      <!-- Mini Map in modal -->
                      <div v-if="selectedInspection.latitude" style="padding:8px;">
                        <button v-if="!showDetailMap" class="btn btn-sm btn-outline-primary w-100" @click="showDetailMapFn">
                          <i class="bx bx-map me-1"></i> View Location on Map
                        </button>
                        <div v-if="showDetailMap">
                          <button class="btn btn-sm btn-outline-secondary w-100 mb-2" @click="hideDetailMap">
                            <i class="bx bx-x me-1"></i> Hide Map
                          </button>
                          <div style="overflow:hidden;border-radius:8px;">
                            <div id="detailMap" style="height:160px;width:100%;position:relative;z-index:1;"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- RIGHT: Details -->
                    <div class="col-lg-7">
                      <div class="p-3">

                        <!-- Business Info -->
                        <div class="mb-3">
                          <h6 class="text-primary mb-2"><i class="bx bx-store me-1"></i> Business</h6>
                          <div class="row g-2" style="font-size:13px;">
                            <div class="col-6"><span class="text-muted">Name:</span><br><strong>{{ selectedInspection.businessName || 'Unregistered' }}</strong></div>
                            <div class="col-6"><span class="text-muted">Business ID:</span><br><strong>{{ selectedInspection.businessID || '—' }}</strong></div>
                            <div class="col-6"><span class="text-muted">Type:</span><br><span class="badge bg-secondary">{{ selectedInspection.inspectionType }}</span></div>
                            <div class="col-6"><span class="text-muted">Date:</span><br><strong>{{ formatDate(selectedInspection.dateCreated) }} {{ formatTime(selectedInspection.dateCreated) }}</strong></div>
                          </div>
                        </div>
                        <hr class="my-2">

                        <!-- Officer Info -->
                        <div class="mb-3">
                          <h6 class="text-primary mb-2"><i class="bx bx-user me-1"></i> Officer</h6>
                          <div class="row g-2" style="font-size:13px;">
                            <div class="col-6"><span class="text-muted">Name:</span><br><strong>{{ selectedInspection.officerNames }}</strong></div>
                            <div class="col-6"><span class="text-muted">ID No:</span><br><strong>{{ selectedInspection.officerIdNo }}</strong></div>
                            <div class="col-6"><span class="text-muted">Sub County:</span><br>{{ selectedInspection.officerSubCountyName || '—' }}</div>
                            <div class="col-6"><span class="text-muted">Ward:</span><br>{{ selectedInspection.officerWardName || '—' }}</div>
                          </div>
                        </div>
                        <hr class="my-2">

                        <!-- GPS Info -->
                        <div class="mb-3" v-if="selectedInspection.latitude">
                          <h6 class="text-primary mb-2"><i class="bx bx-map me-1"></i> GPS Location</h6>
                          <div v-if="selectedInspection.locationAddress" style="font-size:13px;margin-bottom:4px;">
                            <i class="bx bx-map-pin text-success me-1"></i><strong>{{ selectedInspection.locationAddress }}</strong>
                          </div>
                          <div style="font-size:12px;">
                            <span class="text-muted">Coordinates:</span>
                            <span class="text-success ms-1">{{ Number(selectedInspection.latitude).toFixed(6) }}, {{ Number(selectedInspection.longitude).toFixed(6) }}</span>
                            <span v-if="selectedInspection.gpsAccuracy" class="text-muted ms-1">(±{{ selectedInspection.gpsAccuracy }}m)</span>
                          </div>
                        </div>

                        <!-- Verification Checklist -->
                        <div class="mb-3" v-if="selectedInspection.inspectionType === 'VERIFICATION'">
                          <h6 class="text-primary mb-2"><i class="bx bx-check-double me-1"></i> Verification Checklist</h6>
                          <table class="table table-sm table-bordered mb-0" style="font-size:12px;">
                            <thead class="table-light">
                            <tr><th style="width:35%;">Check</th><th style="width:25%;">Result</th><th>Observed Value</th></tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="fw-bold">Permit Displayed</td>
                              <td><span class="badge" :class="selectedInspection.permitDisplayed === 'YES' ? 'bg-success' : selectedInspection.permitDisplayed === 'FAKE' ? 'bg-danger' : 'bg-warning text-dark'">{{ selectedInspection.permitDisplayed || '—' }}</span></td>
                              <td>—</td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Permit Matches System</td>
                              <td><span class="badge" :class="selectedInspection.permitMatches === 'YES' ? 'bg-success' : selectedInspection.permitMatches === 'NO' ? 'bg-danger' : 'bg-secondary'">{{ selectedInspection.permitMatches || '—' }}</span></td>
                              <td>—</td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Business Name</td>
                              <td><span class="badge" :class="selectedInspection.businessNameMatch === 'MATCH' ? 'bg-success' : selectedInspection.businessNameMatch === 'MISMATCH' ? 'bg-danger' : 'bg-secondary'">{{ selectedInspection.businessNameMatch || '—' }}</span></td>
                              <td>{{ selectedInspection.businessNameObserved || '—' }}</td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Category</td>
                              <td><span class="badge" :class="selectedInspection.categoryMatch === 'MATCH' ? 'bg-success' : selectedInspection.categoryMatch === 'MISMATCH' ? 'bg-danger' : 'bg-secondary'">{{ selectedInspection.categoryMatch || '—' }}</span></td>
                              <td>{{ selectedInspection.categoryObserved || '—' }}</td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Employee Count</td>
                              <td>System: {{ selectedInspection.employeeCountSystem || '—' }}</td>
                              <td>Observed: <strong>{{ selectedInspection.employeeCountObserved || '—' }}</strong></td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Premise Size</td>
                              <td><span class="badge" :class="selectedInspection.premiseSizeMatch === 'MATCH' ? 'bg-success' : selectedInspection.premiseSizeMatch === 'MISMATCH' ? 'bg-danger' : 'bg-secondary'">{{ selectedInspection.premiseSizeMatch || '—' }}</span></td>
                              <td>{{ selectedInspection.premiseSizeObserved || '—' }}</td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Owner</td>
                              <td><span class="badge" :class="selectedInspection.ownerMatch === 'MATCH' ? 'bg-success' : selectedInspection.ownerMatch === 'MISMATCH' ? 'bg-danger' : 'bg-secondary'">{{ selectedInspection.ownerMatch || '—' }}</span></td>
                              <td>{{ selectedInspection.ownerObserved || '—' }}</td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Physical Address</td>
                              <td><span class="badge" :class="selectedInspection.addressMatch === 'MATCH' ? 'bg-success' : selectedInspection.addressMatch === 'MISMATCH' ? 'bg-danger' : 'bg-secondary'">{{ selectedInspection.addressMatch || '—' }}</span></td>
                              <td>{{ selectedInspection.addressObserved || '—' }}</td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Fire Licence</td>
                              <td><span class="badge" :class="selectedInspection.fireLicenceDisplayed === 'YES' ? 'bg-success' : selectedInspection.fireLicenceDisplayed === 'NO' ? 'bg-danger' : 'bg-secondary'">{{ selectedInspection.fireLicenceDisplayed || '—' }}</span></td>
                              <td>—</td>
                            </tr>
                            <tr>
                              <td class="fw-bold">Liquor Licence</td>
                              <td><span class="badge" :class="selectedInspection.liquorLicenceDisplayed === 'YES' ? 'bg-success' : selectedInspection.liquorLicenceDisplayed === 'NO' ? 'bg-danger' : 'bg-secondary'">{{ selectedInspection.liquorLicenceDisplayed || '—' }}</span></td>
                              <td>—</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>

                        <!-- Unregistered Business Details -->
                        <div class="mb-3" v-if="selectedInspection.inspectionType === 'NO_PERMIT'">
                          <h6 class="text-primary mb-2"><i class="bx bx-info-circle me-1"></i> Observed Details</h6>
                          <div class="row g-2" style="font-size:13px;">
                            <div class="col-12" v-if="selectedInspection.observedBusinessActivity"><span class="text-muted">Activity:</span><br><strong>{{ selectedInspection.observedBusinessActivity }}</strong></div>
                            <div class="col-6" v-if="selectedInspection.observedOwnerName"><span class="text-muted">Owner:</span><br><strong>{{ selectedInspection.observedOwnerName }}</strong></div>
                            <div class="col-6" v-if="selectedInspection.observedOwnerPhone"><span class="text-muted">Phone:</span><br><strong>{{ selectedInspection.observedOwnerPhone }}</strong></div>
                            <div class="col-12" v-if="selectedInspection.observedPhysicalAddress"><span class="text-muted">Address:</span><br>{{ selectedInspection.observedPhysicalAddress }}</div>
                            <div class="col-6" v-if="selectedInspection.observedSubCountyName"><span class="text-muted">Sub County:</span><br>{{ selectedInspection.observedSubCountyName }}</div>
                            <div class="col-6" v-if="selectedInspection.observedWardName"><span class="text-muted">Ward:</span><br>{{ selectedInspection.observedWardName }}</div>
                          </div>
                        </div>
                        <hr class="my-2">

                        <!-- Verdict & Remarks -->
                        <div class="mb-3">
                          <h6 class="text-primary mb-2"><i class="bx bx-gavel me-1"></i> Verdict & Remarks</h6>
                          <div class="mb-2">
                            <span class="badge" :class="verdictBadge(selectedInspection.verdict)" style="font-size:14px;padding:6px 16px;">{{ selectedInspection.verdict }}</span>
                          </div>
                          <div v-if="selectedInspection.remarks" class="p-3 rounded" style="background:#f8f9fa;font-size:13px;line-height:1.6;">
                            {{ selectedInspection.remarks }}
                          </div>
                          <div v-else class="text-muted" style="font-size:13px;">No remarks provided</div>
                          <div class="mt-2" v-if="selectedInspection.followUpRequired === 'YES'" style="font-size:13px;">
                            <span class="badge bg-warning text-dark"><i class="bx bx-calendar-exclamation me-1"></i>Follow-up required</span>
                            <span v-if="selectedInspection.followUpDate" class="text-muted ms-2">by {{ formatDate(selectedInspection.followUpDate) }}</span>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
                <div class="modal-footer py-2">
                  <small class="text-muted me-auto">Submitted: {{ formatDate(selectedInspection.dateCreated) }} {{ formatTime(selectedInspection.dateCreated) }}</small>
                  <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Success Modal -->
          <div class="modal fade" id="successModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-sm">
              <div class="modal-content text-center">
                <div class="modal-body py-4">
                  <div class="text-success mb-3"><i class="bx bx-check-circle" style="font-size:64px;"></i></div>
                  <h5>Inspection Submitted!</h5>
                  <p class="text-muted mb-0">ID: {{ lastSubmittedID }}</p>
                </div>
                <div class="modal-footer justify-content-center border-0 pt-0">
                  <button class="btn btn-primary" data-bs-dismiss="modal" @click="resetForm">Scan Next</button>
                </div>
              </div>
            </div>
          </div>

          <!-- ==================== TOP UP MODAL ==================== -->
          <TopUpModal
              ref="topUpModal"
              :business-i-d="selectedBusinessID"
              :bill-no="selectedBillNo"
              :fee-i-d="selectedFeeID"
              @success="handleTopUpSuccess"
          />

        </div>
      </div>
    </div>

  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/ToolBar";
import TopUpModal from "@/components/sbp/modals/TopUpModal.vue";
import jsQR from "jsqr";
import { execute, trade, biller, getRight, base } from "@/api";

export default {
  name: "BusinessEnforcement",
  components: { NavigationBar, ToolBar, TopUpModal },
  data() {
    return {
      activeTab: 'scan',
      showScanner: false,
      scannerStream: null,
      searchBusinessID: '',
      fetchingBusiness: false,
      searchError: null,
      businessLoaded: false,
      duplicateConfirmed: false,
      submitting: false,
      compressing: false,
      lastSubmittedID: '',
      selectedInspection: null,
      detailMapInstance: null,
      detailMapMarker: null,
      activePhotoIndex: 0,
      showEnforcementMap: false,
      showUnregMap: false,
      showDetailMap: false,

      // GPS
      gps: { lat: null, lng: null, accuracy: null, address: null },

      // Map instances
      mapInstance: null,
      mapMarker: null,
      unregMapInstance: null,
      unregMapMarker: null,

      // Stats
      myStats: { todayCount: 0, weekCount: 0, totalCount: 0 },

      // Business from API
      business: { data: {}, permit: null, permitValid: false, lastInspection: null, inspectionCount: 0, inspectedToday: false, todayCount: 0 },

      // Verification form
      form: {
        permitDisplayed: null, permitMatches: null,
        businessNameMatch: null, businessNameObserved: '',
        categoryMatch: null, categoryObserved: '',
        employeeCountObserved: '',
        premiseSizeMatch: null, premiseSizeObserved: '',
        ownerMatch: null, ownerObserved: '',
        addressMatch: null, addressObserved: '',
        fireLicenceDisplayed: 'N/A', liquorLicenceDisplayed: 'N/A',
        verdict: '', remarks: '', followUpRequired: 'NO', followUpDate: ''
      },

      // Photos (array of { file, preview, size })
      photos: [],
      unregPhotos: [],

      // Unregistered
      unreg: { businessName: '', businessActivity: '', ownerName: '', ownerPhone: '', physicalAddress: '', subCountyName: '', wardName: '', remarks: '' },

      // My inspections
      myInspections: [],
      myView: 'list',

      // Reports
      allInspections: [], reportStats: null, reportView: 'grid', reportSearch: '', reportDateFrom: '', reportDateTo: '', reportVerdict: '', reportPage: 1, reportRows: 50, reportTotalItems: 0,

      verdictOptions: [
        { value: 'COMPLIANT', label: 'Compliant', activeClass: 'btn-success' },
        { value: 'NON_COMPLIANT', label: 'Non-Compliant', activeClass: 'btn-warning' },
        { value: 'FAKE_PERMIT', label: 'Fake Permit', activeClass: 'btn-danger' },
        { value: 'NO_PERMIT', label: 'No Permit', activeClass: 'btn-danger' },
        { value: 'CLOSED', label: 'Closed', activeClass: 'btn-secondary' },
        { value: 'NOT_FOUND', label: 'Not Found', activeClass: 'btn-info' }
      ],

      // Invoice lookup tab
      invoice: {
        searchBillNo: '',
        loading: false,
        error: null,
        billDetails: null,   // single header row from countyBiller.billdetails
        billInfo: []         // line items from countyBiller.billinfo
      },

      // Payment-prompt panel state, used by the Look Up Invoice tab to
      // send an M-PESA STK push / SMS payment link to the customer when
      // the displayed bill still has an outstanding balance.
      invoicePayment: {
        phoneNumber: '',
        sending: false,
        success: false,
        message: ''
      },

      // Top-up modal state (when officer finds an undercharged business)
      selectedBusinessID: '',
      selectedBillNo: '',
      selectedFeeID: '',

      // Reports → sub-view toggle
      reportSubView: 'inspections',

      // Reports → Issued Invoices sub-view (countyTrade.enforcement_invoices)
      invoicesReport: {
        loading: false,
        rows: [],
        dateFrom: '',
        dateTo: '',
        myOnly: true,
        totalIssued: 0,
        totalPaid: 0,
        totalBalance: 0
      }
    };
  },

  mounted() {
    this.captureGPS();
    this.loadMyInspections();
  },

  methods: {
    getRight(type) { return getRight(type); },

    // ==================== GPS ====================
    captureGPS() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.gps.lat = pos.coords.latitude;
            this.gps.lng = pos.coords.longitude;
            this.gps.accuracy = Math.round(pos.coords.accuracy);
            this.reverseGeocode(this.gps.lat, this.gps.lng);
          },
          (err) => { console.warn('GPS error:', err.message); },
          { enableHighAccuracy: true, timeout: 15000 }
      );
    },

    reverseGeocode(lat, lng) {
      fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`)
          .then(r => r.json())
          .then(d => {
            if (d && d.display_name) {
              this.gps.address = d.display_name.split(',').slice(0, 3).join(',').trim();
            }
          }).catch(() => {});
    },

    // ==================== LEAFLET MAP ====================
    loadLeaflet(cb) {
      if (window.L) { cb(); return; }
      const css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      const js = document.createElement('script');
      js.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      js.onload = cb;
      document.head.appendChild(js);
    },

    initMap(elementId) {
      const self = this;
      this.loadLeaflet(() => {
        self.$nextTick(() => {
          const el = document.getElementById(elementId);
          if (!el) return;

          const isUnreg = elementId === 'unregMap';
          const existingMap = isUnreg ? self.unregMapInstance : self.mapInstance;
          if (existingMap) { existingMap.invalidateSize(); return; }

          const lat = self.gps.lat || -1.2921;
          const lng = self.gps.lng || 36.8219;
          const zoom = self.gps.lat ? 15 : 7;

          const map = L.map(el, { zoomControl: true, attributionControl: false }).setView([lat, lng], zoom);
          L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', { maxZoom: 19, attribution: '© OpenStreetMap © CARTO' }).addTo(map);

          if (isUnreg) {
            self.unregMapInstance = map;
            // Allow tap to move pin for unregistered
            map.on('click', (e) => {
              self.gps.lat = e.latlng.lat;
              self.gps.lng = e.latlng.lng;
              self.updateMapPin(e.latlng.lat, e.latlng.lng, true);
              self.reverseGeocode(e.latlng.lat, e.latlng.lng);
            });
          } else {
            self.mapInstance = map;
          }

          // Drop pin if GPS available
          if (self.gps.lat) {
            self.updateMapPin(lat, lng, isUnreg);
          }

          // Force Leaflet to recalculate container size after render
          setTimeout(() => map.invalidateSize(), 100);
          setTimeout(() => map.invalidateSize(), 300);
          setTimeout(() => map.invalidateSize(), 600);
        });
      });
    },

    updateMapPin(lat, lng, isUnreg) {
      if (!window.L) return;
      const map = isUnreg ? this.unregMapInstance : this.mapInstance;
      if (!map) return;

      const pinIcon = L.divIcon({
        className: 'enforcement-pin',
        html: '<div style="background:#dc3545;width:16px;height:16px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.5);"></div>',
        iconSize: [16, 16], iconAnchor: [8, 8]
      });

      if (isUnreg) {
        if (this.unregMapMarker) { this.unregMapMarker.setLatLng([lat, lng]); }
        else { this.unregMapMarker = L.marker([lat, lng], { icon: pinIcon }).addTo(map); }
      } else {
        if (this.mapMarker) { this.mapMarker.setLatLng([lat, lng]); }
        else { this.mapMarker = L.marker([lat, lng], { icon: pinIcon }).addTo(map); }
      }
      map.setView([lat, lng], Math.max(map.getZoom(), 14));
    },

    // ==================== QR SCANNER ====================
    // iOS Safari (and iOS Chrome — they all use WebKit) does NOT support
    // the BarcodeDetector API, so the previous implementation appeared to
    // open the camera but never actually decoded anything. We now use jsQR
    // (pure JS, works everywhere) as the universal decoder. We still try
    // BarcodeDetector first when it exists because it's faster on Android.
    async startScanner() {
      this.showScanner = true;
      this.searchError = null;

      // Prefer the rear camera; if exact rear isn't available (some iOS
      // devices), fall back to any camera so the officer still gets video.
      const constraintsList = [
        { video: { facingMode: { exact: 'environment' } }, audio: false },
        { video: { facingMode: 'environment' }, audio: false },
        { video: true, audio: false }
      ];
      let stream = null;
      for (const c of constraintsList) {
        try {
          stream = await navigator.mediaDevices.getUserMedia(c);
          if (stream) break;
        } catch (_) { /* try next */ }
      }

      if (!stream) {
        this.searchError = 'Camera not available. Enter Business ID manually.';
        this.showScanner = false;
        return;
      }

      this.scannerStream = stream;
      await this.$nextTick();
      const video = this.$refs.scannerVideo;
      if (!video) {
        this.stopScanner();
        return;
      }
      video.srcObject = stream;
      video.setAttribute('playsinline', 'true');   // iOS belt-and-braces
      video.muted = true;                          // iOS won't autoplay without this
      try { await video.play(); } catch (_) {}

      this.scanLoop();
    },
    scanLoop() {
      if (!this.showScanner || !this.$refs.scannerVideo) return;
      const video = this.$refs.scannerVideo;
      if (video.readyState < 2 || !video.videoWidth) {
        requestAnimationFrame(() => this.scanLoop());
        return;
      }

      // Downscale to ~480px wide for speed; jsQR handles non-1:1 fine.
      const targetW = Math.min(480, video.videoWidth);
      const scale = targetW / video.videoWidth;
      const w = Math.round(video.videoWidth * scale);
      const h = Math.round(video.videoHeight * scale);

      if (!this._qrCanvas) this._qrCanvas = document.createElement('canvas');
      const canvas = this._qrCanvas;
      canvas.width = w; canvas.height = h;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(video, 0, 0, w, h);

      // Try BarcodeDetector first (faster on Android/Chrome) but don't
      // depend on it — fall back to jsQR which works on iOS Safari too.
      const next = () => { if (this.showScanner) requestAnimationFrame(() => this.scanLoop()); };

      if ('BarcodeDetector' in window) {
        try {
          new BarcodeDetector({ formats: ['qr_code'] }).detect(canvas).then(barcodes => {
            if (barcodes && barcodes.length > 0) {
              this.handleQRResult(barcodes[0].rawValue);
              return;
            }
            this.scanWithJsQR(ctx, w, h, next);
          }).catch(() => this.scanWithJsQR(ctx, w, h, next));
          return;
        } catch (_) { /* fall through to jsQR */ }
      }
      this.scanWithJsQR(ctx, w, h, next);
    },
    scanWithJsQR(ctx, w, h, next) {
      try {
        const imageData = ctx.getImageData(0, 0, w, h);
        const code = jsQR(imageData.data, w, h, { inversionAttempts: 'dontInvert' });
        if (code && code.data) {
          this.handleQRResult(code.data);
          return;
        }
      } catch (_) { /* ignore frame */ }
      next();
    },
    handleQRResult(text) {
      let id = text;
      const match = text.match(/print-permit\/(\d+)/);
      if (match) id = match[1];
      else if (text.match(/businessID[=:]\s*(\w+)/i)) id = text.match(/businessID[=:]\s*(\w+)/i)[1];
      else if (text.match(/^\d+$/)) id = text;
      this.searchBusinessID = id;
      this.stopScanner();
      this.fetchBusiness();
    },
    stopScanner() {
      this.showScanner = false;
      if (this.scannerStream) { this.scannerStream.getTracks().forEach(t => t.stop()); this.scannerStream = null; }
    },

    // ==================== FETCH BUSINESS ====================
    async fetchBusiness() {
      if (!this.searchBusinessID) return;
      this.fetchingBusiness = true; this.searchError = null;
      try {
        const data = new FormData();
        data.append('function', 'getBusinessForEnforcement');
        data.append('businessID', this.searchBusinessID);
        const res = await execute(data, trade);
        if (res.data.success && res.data.data) {
          this.business.data = res.data.data.business;
          this.business.permit = res.data.data.activePermit;
          this.business.permitValid = res.data.data.permitValid;
          this.business.lastInspection = res.data.data.lastInspection;
          this.business.inspectionCount = res.data.data.inspectionCount;
          this.business.inspectedToday = res.data.data.inspectedToday || false;
          this.business.todayCount = res.data.data.todayCount || 0;
          this.duplicateConfirmed = false;
          this.businessLoaded = true;
        } else {
          this.searchError = res.data.message || 'Business not found';
        }
      } catch (e) { this.searchError = e.message; }
      this.fetchingBusiness = false;
    },

    // ==================== PHOTO CAPTURE & COMPRESSION ====================
    handlePhotoCapture(e) { this.processFiles(e.target.files, 'photos'); e.target.value = ''; },
    handlePhotoGallery(e) { this.processFiles(e.target.files, 'photos'); e.target.value = ''; },
    handleUnregPhotoCapture(e) { this.processFiles(e.target.files, 'unregPhotos'); e.target.value = ''; },
    handleUnregPhotoGallery(e) { this.processFiles(e.target.files, 'unregPhotos'); e.target.value = ''; },

    processFiles(fileList, targetArray) {
      const files = Array.from(fileList || []).filter(f => f.type.startsWith('image/'));
      const remaining = 5 - this[targetArray].length;
      const toProcess = files.slice(0, remaining);
      if (toProcess.length === 0) return;

      this.compressing = true;
      let processed = 0;
      const self = this;

      toProcess.forEach(file => {
        self.compressImage(file, 1200, 0.7, (compressedFile, previewUrl) => {
          self[targetArray].push({ file: compressedFile, preview: previewUrl, size: compressedFile.size });
          processed++;
          if (processed >= toProcess.length) self.compressing = false;
        });
      });
    },

    compressImage(file, maxDim, quality, callback) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          let w = img.width, h = img.height;
          if (w > maxDim || h > maxDim) {
            if (w > h) { h = Math.round(h * maxDim / w); w = maxDim; }
            else { w = Math.round(w * maxDim / h); h = maxDim; }
          }
          const canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);

          canvas.toBlob((blob) => {
            if (!blob) { callback(file, e.target.result); return; }
            // If still over 2MB, reduce quality further
            if (blob.size > 2 * 1024 * 1024) {
              canvas.toBlob((blob2) => {
                const final = blob2 || blob;
                const compressed = new File([final], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' });
                callback(compressed, URL.createObjectURL(compressed));
              }, 'image/jpeg', 0.5);
            } else {
              const compressed = new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' });
              callback(compressed, URL.createObjectURL(compressed));
            }
          }, 'image/jpeg', quality);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removePhoto(idx) {
      URL.revokeObjectURL(this.photos[idx].preview);
      this.photos.splice(idx, 1);
    },

    formatFileSize(bytes) {
      if (!bytes) return '0 KB';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },

    // ==================== SUBMIT INSPECTION ====================
    async submitInspection() {
      if (!this.form.verdict) { alert('Please select a verdict'); return; }
      if (this.photos.length === 0) { alert('Please take at least one photo'); return; }

      this.submitting = true;
      try {
        const data = new FormData();
        data.append('function', 'submitInspection');
        data.append('businessID', this.business.data.businessID);
        data.append('businessName', this.business.data.businessName);
        data.append('inspectionType', 'VERIFICATION');

        if (this.gps.lat) { data.append('latitude', this.gps.lat); data.append('longitude', this.gps.lng); data.append('gpsAccuracy', this.gps.accuracy); if (this.gps.address) data.append('locationAddress', this.gps.address); }

        Object.keys(this.form).forEach(key => { if (this.form[key] !== null && this.form[key] !== '') data.append(key, this.form[key]); });
        data.append('employeeCountSystem', this.business.data.numberOfEmployees || '');

        this.photos.forEach((ph, i) => data.append(`photo_${i}`, ph.file));

        const res = await execute(data, trade);
        if (res.data.success) {
          this.lastSubmittedID = res.data.data.inspectionID;
          const modal = new bootstrap.Modal(document.getElementById('successModal'));
          modal.show();
          this.loadMyInspections();
        } else { alert(res.data.message || 'Failed'); }
      } catch (e) { alert('Error: ' + e.message); }
      this.submitting = false;
    },

    // ==================== SUBMIT UNREGISTERED ====================
    async submitUnregistered() {
      if (!this.unreg.businessName) { alert('Business name is required'); return; }
      this.submitting = true;
      try {
        const data = new FormData();
        data.append('function', 'submitInspection');
        data.append('businessID', '');
        data.append('businessName', this.unreg.businessName);
        data.append('inspectionType', 'NO_PERMIT');
        data.append('verdict', 'NO_PERMIT');
        data.append('remarks', this.unreg.remarks);
        data.append('observedBusinessActivity', this.unreg.businessActivity);
        data.append('observedOwnerName', this.unreg.ownerName);
        data.append('observedOwnerPhone', this.unreg.ownerPhone);
        data.append('observedPhysicalAddress', this.unreg.physicalAddress);
        data.append('observedSubCountyName', this.unreg.subCountyName);
        data.append('observedWardName', this.unreg.wardName);

        if (this.gps.lat) { data.append('latitude', this.gps.lat); data.append('longitude', this.gps.lng); data.append('gpsAccuracy', this.gps.accuracy); if (this.gps.address) data.append('locationAddress', this.gps.address); }

        this.unregPhotos.forEach((ph, i) => data.append(`photo_${i}`, ph.file));

        const res = await execute(data, trade);
        if (res.data.success) {
          this.lastSubmittedID = res.data.data.inspectionID;
          const modal = new bootstrap.Modal(document.getElementById('successModal'));
          modal.show();
          this.unreg = { businessName: '', businessActivity: '', ownerName: '', ownerPhone: '', physicalAddress: '', subCountyName: '', wardName: '', remarks: '' };
          this.unregPhotos.forEach(p => URL.revokeObjectURL(p.preview));
          this.unregPhotos = [];
          this.loadMyInspections();
        } else { alert(res.data.message || 'Failed'); }
      } catch (e) { alert('Error: ' + e.message); }
      this.submitting = false;
    },

    // ==================== LOAD DATA ====================
    async loadMyInspections() {
      try {
        const data = new FormData(); data.append('function', 'getMyInspections');
        const res = await execute(data, trade);
        if (res.data.success && res.data.data) {
          this.myInspections = res.data.data.todayInspections || [];
          this.myStats.todayCount = res.data.data.todayCount || 0;
          this.myStats.weekCount = res.data.data.weekCount || 0;
          this.myStats.totalCount = res.data.data.totalCount || 0;
        }
      } catch (e) { console.error(e); }
    },

    async loadAllInspections() {
      try {
        const data = new FormData();
        data.append('function', 'getInspections');
        data.append('page', this.reportPage);
        data.append('rows_per_page', this.reportRows);
        if (this.reportSearch) data.append('search', this.reportSearch);
        if (this.reportDateFrom) data.append('dateFrom', this.reportDateFrom);
        if (this.reportDateTo) data.append('dateTo', this.reportDateTo);
        if (this.reportVerdict) data.append('filterVerdict', this.reportVerdict);
        const res = await execute(data, trade);
        if (res.data.success && res.data.data) {
          this.allInspections = res.data.data.inspections || [];
          this.reportTotalItems = res.data.data.totalItems || 0;
          this.reportStats = res.data.data.stats;
        }
      } catch (e) { console.error(e); }
    },

    // ==================== HELPERS ====================
    openDetail(ins) {
      this.selectedInspection = ins;
      this.activePhotoIndex = 0;
      this.showDetailMap = false;
      const modal = new bootstrap.Modal(document.getElementById('detailModal'));
      modal.show();
      // Destroy detail map when modal closes
      const self = this;
      document.getElementById('detailModal').addEventListener('hidden.bs.modal', function handler() {
        self.showDetailMap = false;
        if (self.detailMapInstance) { self.detailMapInstance.remove(); self.detailMapInstance = null; }
        document.getElementById('detailModal').removeEventListener('hidden.bs.modal', handler);
      });
    },

    showDetailMapFn() {
      this.showDetailMap = true;
      if (this.selectedInspection && this.selectedInspection.latitude) {
        this.$nextTick(() => this.initDetailMap(Number(this.selectedInspection.latitude), Number(this.selectedInspection.longitude)));
      }
    },

    hideDetailMap() {
      this.showDetailMap = false;
      if (this.detailMapInstance) { this.detailMapInstance.remove(); this.detailMapInstance = null; }
    },

    toggleMap(which) {
      if (which === 'enforcement') {
        this.showEnforcementMap = !this.showEnforcementMap;
        if (this.showEnforcementMap) {
          this.$nextTick(() => this.initMap('enforcementMap'));
        } else {
          if (this.mapInstance) { this.mapInstance.remove(); this.mapInstance = null; this.mapMarker = null; }
        }
      } else if (which === 'unreg') {
        this.showUnregMap = !this.showUnregMap;
        if (this.showUnregMap) {
          this.$nextTick(() => this.initMap('unregMap'));
        } else {
          if (this.unregMapInstance) { this.unregMapInstance.remove(); this.unregMapInstance = null; this.unregMapMarker = null; }
        }
      }
    },

    initDetailMap(lat, lng) {
      this.loadLeaflet(() => {
        this.$nextTick(() => {
          const el = document.getElementById('detailMap');
          if (!el) return;
          if (this.detailMapInstance) { this.detailMapInstance.remove(); this.detailMapInstance = null; }
          const map = L.map(el, { zoomControl: true, attributionControl: false, dragging: true, scrollWheelZoom: false }).setView([lat, lng], 15);
          L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', { maxZoom: 19 }).addTo(map);
          const pinIcon = L.divIcon({
            className: 'detail-pin',
            html: '<div style="background:#dc3545;width:18px;height:18px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.5);"></div>',
            iconSize: [18, 18], iconAnchor: [9, 9]
          });
          L.marker([lat, lng], { icon: pinIcon }).addTo(map);
          this.detailMapInstance = map;
          setTimeout(() => map.invalidateSize(), 100);
          setTimeout(() => map.invalidateSize(), 300);
          setTimeout(() => map.invalidateSize(), 600);
        });
      });
    },

    switchToUnregistered() {
      this.activeTab = 'unregistered';
    },

    resetForm() {
      this.businessLoaded = false;
      this.searchBusinessID = '';
      this.searchError = null;
      this.business = { data: {}, permit: null, permitValid: false, lastInspection: null, inspectionCount: 0, inspectedToday: false, todayCount: 0 };
      this.duplicateConfirmed = false;
      this.form = {
        permitDisplayed: null, permitMatches: null,
        businessNameMatch: null, businessNameObserved: '',
        categoryMatch: null, categoryObserved: '',
        employeeCountObserved: '',
        premiseSizeMatch: null, premiseSizeObserved: '',
        ownerMatch: null, ownerObserved: '',
        addressMatch: null, addressObserved: '',
        fireLicenceDisplayed: 'N/A', liquorLicenceDisplayed: 'N/A',
        verdict: '', remarks: '', followUpRequired: 'NO', followUpDate: ''
      };
      this.photos.forEach(p => URL.revokeObjectURL(p.preview));
      this.photos = [];
      this.showEnforcementMap = false;
      this.showUnregMap = false;
      this.showDetailMap = false;
      if (this.mapInstance) { this.mapInstance.remove(); this.mapInstance = null; this.mapMarker = null; }
      if (this.unregMapInstance) { this.unregMapInstance.remove(); this.unregMapInstance = null; this.unregMapMarker = null; }
      if (this.detailMapInstance) { this.detailMapInstance.remove(); this.detailMapInstance = null; }
      this.captureGPS();
    },

    verdictBadge(v) {
      return { COMPLIANT: 'bg-success', NON_COMPLIANT: 'bg-warning text-dark', FAKE_PERMIT: 'bg-danger', NO_PERMIT: 'bg-danger', CLOSED: 'bg-secondary', NOT_FOUND: 'bg-info' }[v] || 'bg-secondary';
    },
    photoCount(json) { try { return JSON.parse(json || '[]').length; } catch { return 0; } },
    getPhotoUrls(json) {
      try {
        const filenames = JSON.parse(json || '[]');
        const photoBase = base + '/trade/uploads/inspections/';
        return filenames.map(f => photoBase + f);
      } catch { return []; }
    },
    formatDate(d) { return d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : ''; },
    formatTime(d) { return d ? new Date(d).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : ''; },

    // ==================== INVOICE LOOKUP ====================
    searchInvoice() {
      const billNo = (this.invoice.searchBillNo || '').trim();
      if (!billNo) {
        this.invoice.error = 'Please enter an invoice number.';
        return;
      }

      this.invoice.loading = true;
      this.invoice.error = null;
      this.invoice.billDetails = null;
      this.invoice.billInfo = [];

      const data = new FormData();
      data.append('function', 'getBill');
      data.append('billNo', billNo);
      data.append('sessionNames', sessionStorage.getItem('sessionNames') || '');
      data.append('sessionIdNo', sessionStorage.getItem('sessionIdNo') || '');

      execute(data, biller)
          .then((res) => {
            this.invoice.loading = false;
            if (res.data && res.data.success) {
              this.invoice.billDetails = res.data.data.billDetails || null;
              this.invoice.billInfo = res.data.data.billInfo || [];
              if (!this.invoice.billDetails) {
                this.invoice.error = `No invoice found for "${billNo}".`;
              } else {
                // Reset and pre-fill the payment-prompt panel from this bill
                this.invoicePayment = {
                  phoneNumber: this.invoice.billDetails.customerPhoneNumber || '',
                  sending: false,
                  success: false,
                  message: ''
                };
              }
            } else {
              this.invoice.error = (res.data && res.data.message) || `No invoice found for "${billNo}".`;
            }
          })
          .catch((e) => {
            this.invoice.loading = false;
            this.invoice.error = 'Could not look up invoice: ' + (e.message || 'unknown error');
          });
    },

    // Send the customer an M-PESA STK push / SMS payment link for the
    // currently-loaded bill. Reuses the existing makePayment API path
    // (same as /new-bill). Picks the right backend stream by bill prefix.
    sendInvoicePaymentPrompt() {
      const bd = this.invoice.billDetails;
      if (!bd || !bd.billNo) return;
      const phone = (this.invoicePayment.phoneNumber || '').trim();
      if (!phone) {
        this.invoicePayment.success = false;
        this.invoicePayment.message = 'Enter the customer phone number first.';
        return;
      }

      this.invoicePayment.sending = true;
      this.invoicePayment.message = '';
      this.invoicePayment.success = false;

      const paymentData = {
        accNo: bd.billNo,
        amount: bd.billBalance || bd.detailAmount || 0,
        payBillNo: '',                    // backend resolves from bill prefix
        phoneNumber: phone,
        paymentMode: 'MPESA',
        sessionPhoneNumber: sessionStorage.getItem('sessionPhoneNumber') || '',
        sessionNames: sessionStorage.getItem('sessionNames') || '',
        sessionIdNo: sessionStorage.getItem('sessionIdNo') || ''
      };

      const data = new FormData();
      data.append('function', 'makePayment');
      data.append('paymentData', JSON.stringify(paymentData));

      // Pick stream by bill prefix — same pattern NewBill.vue uses.
      const prefix = String(bd.billNo).toUpperCase();
      let stream = biller;
      if (prefix.startsWith('SBP')) stream = trade;
      // PKN/RNT could be added if those streams are imported here; biller is
      // the safe default and works for BLL-prefixed enforcement bills.

      execute(data, stream)
          .then((res) => {
            this.invoicePayment.sending = false;
            if (res.data && res.data.success) {
              this.invoicePayment.success = true;
              this.invoicePayment.message = `Payment prompt sent to ${phone}. Ask the customer to check their phone and enter their M-PESA PIN.`;
            } else {
              this.invoicePayment.success = false;
              this.invoicePayment.message = (res.data && res.data.message) || 'Could not send the payment prompt. Please try again.';
            }
          })
          .catch((e) => {
            this.invoicePayment.sending = false;
            this.invoicePayment.success = false;
            this.invoicePayment.message = 'Network error sending prompt: ' + (e.message || 'unknown');
          });
    },

    formatMoney(value) {
      const n = parseFloat(value);
      if (isNaN(n)) return '0.00';
      return n.toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    formatInvoiceDate(d) {
      if (!d) return '';
      const dt = new Date(d);
      if (isNaN(dt.getTime())) return d;
      return dt.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    },

    invoiceStatusBadge(status) {
      const s = (status || '').toUpperCase();
      if (s === 'PAID') return 'bg-success';
      if (s === 'PARTIAL') return 'bg-warning text-dark';
      if (s === 'CANCELLED' || s === 'VOID') return 'bg-secondary';
      return 'bg-danger';
    },

    // ==================== ISSUE NEW SBP INVOICE ====================
    // Routes to /new-bill with ?source=enforcement so that flow knows
    // to lock to SBP and tag the resulting bill in countyTrade.
    goInvoiceBusiness() {
      this.$router.push({ path: '/new-bill', query: { source: 'enforcement' } });
    },

    // ==================== ISSUED INVOICES REPORT ====================
    loadIssuedInvoices() {
      this.invoicesReport.loading = true;
      this.invoicesReport.rows = [];

      const data = new FormData();
      data.append('function', 'getEnforcementInvoices');
      data.append('page', '1');
      data.append('rows_per_page', '200');
      if (this.invoicesReport.dateFrom) data.append('dateFrom', this.invoicesReport.dateFrom);
      if (this.invoicesReport.dateTo)   data.append('dateTo',   this.invoicesReport.dateTo);
      data.append('myOnly', this.invoicesReport.myOnly ? 'true' : 'false');
      data.append('sessionIdNo', sessionStorage.getItem('sessionIdNo') || '');
      data.append('sessionNames', sessionStorage.getItem('sessionNames') || '');

      execute(data, biller)
          .then((res) => {
            this.invoicesReport.loading = false;
            if (res.data && res.data.success) {
              const d = res.data.data || {};
              this.invoicesReport.rows = d.invoices || [];
              this.invoicesReport.totalIssued = d.totalIssued || 0;
              this.invoicesReport.totalPaid = d.totalPaid || 0;
              this.invoicesReport.totalBalance = d.totalBalance || 0;
            }
          })
          .catch((e) => {
            this.invoicesReport.loading = false;
            console.error('loadIssuedInvoices', e);
          });
    },

    // Click an issued-invoice row → drop into the Look Up Invoice tab
    // pre-filled with that billNo, so officer sees the full bill details.
    openInvoiceFromReport(row) {
      if (!row || !row.billNo) return;
      this.activeTab = 'invoice';
      this.invoice.searchBillNo = row.billNo;
      this.$nextTick(() => this.searchInvoice());
    },

    // ==================== VIEW INVOICE ====================
    // Drops the officer into the existing Look Up Invoice tab pre-filled
    // with the loaded business's billNo, so they can see exactly what
    // line items were charged before deciding to top up.
    viewInvoiceForLoadedBusiness() {
      const billNo = (this.business && this.business.permit && this.business.permit.billNo) || '';
      if (!billNo) {
        alert('No invoice/billNo found on this business.');
        return;
      }
      this.activeTab = 'invoice';
      this.invoice.searchBillNo = billNo;
      this.$nextTick(() => this.searchInvoice());
    },

    // ==================== VIEW PERMIT ====================
    // Mirrors Approved.vue's printTradePermitBillNo. Pulls the active
    // permit's billNo from the loaded business, hits the trade backend
    // to confirm, then opens the existing /trade print page in a new tab.
    viewPermit() {
      const billNo = (this.business && this.business.permit && this.business.permit.billNo) || '';
      if (!billNo) {
        alert('No permit billNo found on this business.');
        return;
      }
      const data = new FormData();
      data.append('function', 'printTradePermit');
      data.append('billNo', billNo);
      execute(data, trade)
          .then((res) => {
            if (res.data && res.data.success) {
              localStorage['params'] = JSON.stringify({ billNo: billNo });
              const routeData = this.$router.resolve({ name: 'trade' });
              window.open(routeData.href, '_blank');
            } else {
              alert((res.data && res.data.message) || 'Could not load permit.');
            }
          })
          .catch((e) => alert('Error opening permit: ' + (e.message || 'unknown')));
    },

    // ==================== TOP UP (UNDERCHARGED BUSINESS) ====================
    // Reuses the same TopUpModal Approved.vue uses. After the modal's
    // own generateBill flow succeeds, handleTopUpSuccess gets called
    // and tags the resulting bill in countyTrade.enforcement_invoices.
    openTopUpForLoadedBusiness() {
      const b = this.business || {};
      const p = b.permit || {};
      this.selectedBusinessID = b.data && b.data.businessID || '';
      this.selectedBillNo     = p.billNo || (b.data && b.data.billNo) || '';
      this.selectedFeeID      = p.feeID  || (b.data && b.data.feeID)  || '';

      if (!this.selectedBusinessID) {
        alert('No business loaded.');
        return;
      }

      this.$nextTick(() => {
        const el = document.getElementById('topUpModal');
        if (el) {
          const modal = new bootstrap.Modal(el);
          modal.show();
        }
        if (this.$refs.topUpModal && typeof this.$refs.topUpModal.initModal === 'function') {
          this.$refs.topUpModal.initModal();
        }
      });
    },

    handleTopUpSuccess(result) {
      // Tag the just-issued top-up bill as enforcement-raised so it
      // appears in the team's "Issued Invoices" report.
      const newBillNo = (result && (result.billNo || result.newBillNo)) || '';
      if (!newBillNo) return;

      const b = this.business || {};
      const data = new FormData();
      data.append('function', 'recordEnforcementInvoice');
      data.append('billNo', newBillNo);
      data.append('businessID', (b.data && b.data.businessID) || '');
      data.append('businessName', (b.data && b.data.businessName) || '');
      data.append('customerPhone', (b.data && (b.data.ownerPhone || b.data.phoneNumber)) || '');
      data.append('amount', (result && (result.amount || result.billBalance)) || 0);
      data.append('subCountyName', (b.data && b.data.subCountyName) || '');
      data.append('wardName', (b.data && b.data.wardName) || '');
      data.append('inspectionID', '');
      data.append('sessionNames', sessionStorage.getItem('sessionNames') || '');
      data.append('sessionIdNo', sessionStorage.getItem('sessionIdNo') || '');
      execute(data, biller).catch((e) => console.error('recordEnforcementInvoice (top-up) failed', e));
    }
  },

  beforeUnmount() {
    this.stopScanner();
    this.photos.forEach(p => URL.revokeObjectURL(p.preview));
    this.unregPhotos.forEach(p => URL.revokeObjectURL(p.preview));
    if (this.mapInstance) this.mapInstance.remove();
    if (this.unregMapInstance) this.unregMapInstance.remove();
    if (this.detailMapInstance) this.detailMapInstance.remove();
  }
};
</script>

<style scoped>
/* ============ TABS ============ */
.nav-tabs-custom { border-bottom: 2px solid #f0f0f0; }
.nav-tabs-custom .nav-link {
  font-weight: 600; color: #8c8c8c; border: none; border-bottom: 3px solid transparent;
  padding: 12px 20px; font-size: 14px; transition: all 0.2s; letter-spacing: 0.3px;
}
.nav-tabs-custom .nav-link:hover { color: #556ee6; background: rgba(85,110,230,0.04); }
.nav-tabs-custom .nav-link.active { color: #556ee6; border-bottom-color: #556ee6; background: rgba(85,110,230,0.06); border-radius: 8px 8px 0 0; }

/* ============ STATS CARDS ============ */
.card.mini-stats-wid { transition: transform 0.2s, box-shadow 0.2s; border-radius: 12px !important; border: none !important; }
.card.mini-stats-wid:hover { transform: translateY(-3px); box-shadow: 0 8px 25px rgba(0,0,0,0.08) !important; }
.card.mini-stats-wid .card-body { padding: 20px; }

/* ============ SCAN LANDING ============ */
.scan-landing { text-align: center; padding: 40px 0 20px; }
.scan-hero-icon {
  width: 80px; height: 80px; border-radius: 50%; margin: 0 auto 20px;
  background: linear-gradient(135deg, #556ee6 0%, #7b8ff7 100%);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 8px 30px rgba(85,110,230,0.3);
  animation: pulse-glow 2s ease-in-out infinite;
}
.scan-hero-icon i { font-size: 36px; color: #fff; }
@keyframes pulse-glow {
  0%, 100% { box-shadow: 0 8px 30px rgba(85,110,230,0.3); }
  50% { box-shadow: 0 8px 40px rgba(85,110,230,0.5); }
}
.scan-title { font-size: 22px; font-weight: 700; color: #2c3e50; margin-bottom: 8px; }
.scan-subtitle { font-size: 14px; color: #8c8c8c; margin-bottom: 28px; line-height: 1.5; }
.scan-btn {
  display: flex; align-items: center; gap: 14px; width: 100%; padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fe 0%, #eef0fb 100%); border: 2px solid #e0e4f5;
  border-radius: 14px; cursor: pointer; transition: all 0.25s; text-align: left;
}
.scan-btn:hover { border-color: #556ee6; background: linear-gradient(135deg, #eef0fb 0%, #e0e4f5 100%); transform: translateY(-2px); box-shadow: 0 4px 15px rgba(85,110,230,0.15); }
.scan-btn-icon {
  width: 48px; height: 48px; border-radius: 12px; flex-shrink: 0;
  background: linear-gradient(135deg, #556ee6 0%, #7b8ff7 100%);
  display: flex; align-items: center; justify-content: center;
}
.scan-btn-icon i { font-size: 22px; color: #fff; }
.scan-btn-text { flex: 1; }
.scan-btn-text strong { display: block; font-size: 15px; color: #2c3e50; }
.scan-btn-text small { font-size: 12px; color: #8c8c8c; }
.scan-btn-arrow { font-size: 20px; color: #bbb; transition: transform 0.2s; }
.scan-btn:hover .scan-btn-arrow { transform: translateX(3px); color: #556ee6; }
.scanner-video { width: 100%; max-height: 300px; background: #000; border-radius: 14px; border: 3px solid #556ee6; }

/* Divider */
.divider-text { display: flex; align-items: center; gap: 16px; margin: 24px 0; color: #bbb; font-size: 13px; }
.divider-text::before, .divider-text::after { content: ''; flex: 1; height: 1px; background: #e8e8e8; }

/* Search Input */
.search-input-wrap { display: flex; align-items: center; position: relative; }
.search-input-icon { position: absolute; left: 16px; font-size: 20px; color: #bbb; z-index: 2; }
.search-input {
  flex: 1; padding: 14px 16px 14px 46px; border: 2px solid #e8e8e8; border-radius: 12px 0 0 12px;
  font-size: 15px; color: #2c3e50; transition: border-color 0.2s; outline: none; background: #fafafa;
}
.search-input:focus { border-color: #556ee6; background: #fff; box-shadow: 0 0 0 4px rgba(85,110,230,0.08); }
.search-input::placeholder { color: #c0c0c0; }
.search-input-btn {
  padding: 14px 24px; background: linear-gradient(135deg, #556ee6 0%, #7b8ff7 100%); color: #fff;
  border: 2px solid #556ee6; border-left: none; border-radius: 0 12px 12px 0;
  font-weight: 600; font-size: 15px; cursor: pointer; transition: all 0.2s; white-space: nowrap;
}
.search-input-btn:hover { background: linear-gradient(135deg, #4a5fd4 0%, #6a7ee6 100%); }
.search-input-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* ============ FORM FIELDS ============ */
.form-control, .form-select {
  border-radius: 10px !important; border: 2px solid #e8e8e8 !important; padding: 10px 14px !important;
  font-size: 14px !important; transition: all 0.2s !important; background: #fafafa !important;
}
.form-control:focus, .form-select:focus {
  border-color: #556ee6 !important; background: #fff !important;
  box-shadow: 0 0 0 4px rgba(85,110,230,0.08) !important;
}
.form-control::placeholder { color: #c0c0c0 !important; }
.form-label { font-size: 13px !important; font-weight: 600 !important; color: #4a5568 !important; margin-bottom: 6px !important; letter-spacing: 0.3px; }

/* ============ CHECKLIST BUTTONS ============ */
.btn-group .btn {
  font-size: 13px; font-weight: 600; padding: 8px 12px; border-radius: 8px !important;
  transition: all 0.2s; letter-spacing: 0.3px;
}
.btn-group .btn.btn-outline-secondary { border-color: #e0e0e0; color: #888; background: #fafafa; }
.btn-group .btn.btn-outline-secondary:hover { border-color: #556ee6; color: #556ee6; background: rgba(85,110,230,0.04); }
.btn-group .btn.btn-primary {
  background: linear-gradient(135deg, #556ee6 0%, #7b8ff7 100%) !important;
  border-color: #556ee6 !important; color: #fff !important;
  box-shadow: 0 2px 8px rgba(85,110,230,0.3);
}

/* ============ CARDS ============ */
.card.border { border-radius: 14px !important; border-color: #eaeaea !important; overflow: hidden; }
.card-header.bg-light { background: #f8f9fe !important; border-bottom: 1px solid #eef0f5 !important; }
.card-header.bg-primary { background: linear-gradient(135deg, #556ee6 0%, #7b8ff7 100%) !important; border: none !important; }
.card-header.bg-warning { background: linear-gradient(135deg, #f1b44c 0%, #f7c96e 100%) !important; border: none !important; }
.card-header h6 { font-size: 14px; font-weight: 700; letter-spacing: 0.3px; }

/* ============ PHOTO CAPTURE ============ */
.photo-capture-btn {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  width: 100px; height: 100px; border-radius: 12px; cursor: pointer; transition: all 0.2s;
  border: 2px dashed #d0d0d0; background: #fafafa;
}
.photo-capture-btn:hover { border-color: #556ee6; background: rgba(85,110,230,0.04); transform: scale(1.03); }

/* ============ VERDICT BUTTONS ============ */
.btn-success { background: linear-gradient(135deg, #34c38f 0%, #50d4a5 100%) !important; border-color: #34c38f !important; }
.btn-success:hover { background: linear-gradient(135deg, #2db57d 0%, #45c99a 100%) !important; }
.btn-warning { background: linear-gradient(135deg, #f1b44c 0%, #f7c96e 100%) !important; border-color: #f1b44c !important; color: #fff !important; }
.btn-danger { background: linear-gradient(135deg, #f46a6a 0%, #f78888 100%) !important; border-color: #f46a6a !important; }

/* ============ BADGES ============ */
.badge { border-radius: 6px !important; padding: 5px 10px !important; font-weight: 600 !important; letter-spacing: 0.3px; font-size: 11px !important; }
.badge.bg-success { background: linear-gradient(135deg, #34c38f 0%, #50d4a5 100%) !important; }
.badge.bg-danger { background: linear-gradient(135deg, #f46a6a 0%, #f78888 100%) !important; }
.badge.bg-warning { background: linear-gradient(135deg, #f1b44c 0%, #f7c96e 100%) !important; }
.badge.bg-secondary { background: linear-gradient(135deg, #74788d 0%, #8b8fa0 100%) !important; }
.badge.bg-info { background: linear-gradient(135deg, #50a5f1 0%, #73b8f5 100%) !important; }

/* ============ REPORT CARDS ============ */
.inspection-card { transition: transform 0.2s, box-shadow 0.2s; border-radius: 14px !important; }
.inspection-card:hover { transform: translateY(-4px); box-shadow: 0 8px 25px rgba(0,0,0,0.1)!important; }

/* ============ TABLE ============ */
.table { border-radius: 12px; overflow: hidden; }
.table thead th { background: #f8f9fe !important; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; color: #8c8c8c; font-weight: 600; border-bottom: 2px solid #eef0f5 !important; padding: 12px 10px; }
.table tbody tr { transition: background 0.15s; }
.table tbody tr:hover { background: rgba(85,110,230,0.03) !important; }
.table td { padding: 10px !important; vertical-align: middle; border-color: #f5f5f5 !important; }

/* ============ ALERTS ============ */
.alert-warning { background: #fff8ec !important; border-color: #f7e2b8 !important; color: #b87d15 !important; border-radius: 12px !important; }
.alert-info { background: #eef6ff !important; border-color: #c5dff8 !important; color: #3574a8 !important; border-radius: 12px !important; }
.alert-danger { background: #fff2f2 !important; border-color: #f5c6c6 !important; color: #c53030 !important; border-radius: 12px !important; }

/* ============ SUBMIT BUTTON ============ */
.btn-lg {
  border-radius: 12px !important; font-size: 16px !important; font-weight: 700 !important;
  padding: 14px 28px !important; letter-spacing: 0.3px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
  transition: all 0.25s !important;
}
.btn-lg:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,0,0,0.2); }

/* ============ MAP ============ */
#detailMap, #enforcementMap, #unregMap { z-index: 1 !important; border-radius: 10px; }
#detailMap .leaflet-control-container, #enforcementMap .leaflet-control-container, #unregMap .leaflet-control-container { z-index: 2 !important; }

/* ============ DETAIL MODAL ============ */
.modal-xl .modal-content { border-radius: 16px !important; overflow: hidden; border: none !important; box-shadow: 0 20px 60px rgba(0,0,0,0.15) !important; }
.modal-header { background: #f8f9fe; border-bottom: 1px solid #eef0f5 !important; }
.modal-footer { background: #f8f9fe; border-top: 1px solid #eef0f5 !important; }

/* ============ SCROLLBAR ============ */
::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #d0d0d0; border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: #aaa; }

/* "Invoice Business" big-button — same shape as the QR scanner button
   but with a red accent to signal an enforcement action. */
.scan-btn.invoice-btn {
  border-color: rgba(220, 53, 69, 0.35);
}
.scan-btn.invoice-btn:hover {
  border-color: rgba(220, 53, 69, 0.6);
  background: rgba(220, 53, 69, 0.04);
}
.scan-btn.invoice-btn .scan-btn-icon {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}
.scan-btn.invoice-btn .scan-btn-text strong {
  color: #b02a37;
}

/* ============================================================
   MOBILE / IPHONE RESPONSIVENESS
   ============================================================ */

/* iOS / Android: kill the gray flash on tap, allow text selection where it
   matters, and respect notch / home-indicator safe areas. */
::v-deep(button), button, a, .scan-btn {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}

/* Page padding respects iPhone notch + home indicator. */
.page-content {
  padding-left: max(12px, env(safe-area-inset-left));
  padding-right: max(12px, env(safe-area-inset-right));
  padding-bottom: max(20px, env(safe-area-inset-bottom));
}

/* ---- Tablet & smaller (≤768px) ---- */
@media (max-width: 768px) {
  .scan-hero-icon { width: 64px; height: 64px; }
  .scan-hero-icon i { font-size: 28px; }
  .scan-title { font-size: 18px; }

  /* Tabs: scroll horizontally instead of wrapping into 2-3 messy lines */
  .nav-tabs-custom {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .nav-tabs-custom::-webkit-scrollbar { display: none; }
  .nav-tabs-custom .nav-link {
    padding: 10px 14px;
    font-size: 13px;
    white-space: nowrap;
  }

  /* QR scanner video — fill the available width nicely, keep aspect */
  .scanner-video {
    width: 100%;
    max-height: 60vh;
    border-radius: 12px;
  }
}

/* ---- Phone (≤575.98px) ---- */
@media (max-width: 575.98px) {
  /* Page title shrinks, breadcrumb hides on phones to save space */
  .page-title-box h4 { font-size: 16px; }
  .page-title-right { display: none !important; }

  /* Stat cards in two columns on phones, smaller padding */
  .mini-stats-wid .card-body { padding: 10px; }
  .mini-stats-wid h4 { font-size: 18px; }

  /* Big scan landing buttons get bigger tap targets and stack vertically */
  .scan-btn {
    min-height: 64px;
    padding: 14px 16px;
    align-items: center;
  }
  .scan-btn-icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
  }
  .scan-btn-text strong { font-size: 15px; }
  .scan-btn-text small { font-size: 11px; }

  /* Form inputs: 16px font prevents iOS auto-zoom on focus */
  .form-control, .form-select, .search-input {
    font-size: 16px !important;
    min-height: 44px;
  }
  textarea.form-control { min-height: 88px; }

  /* Buttons: minimum 44px tap height (Apple HIG) */
  .btn:not(.btn-sm):not(.btn-xs):not(.btn-link) {
    min-height: 44px;
  }
  .btn-sm { min-height: 38px; }

  /* Section cards breathe a bit more, are full-bleed */
  .card.border { border-radius: 10px; }
  .card-body { padding: 12px; }

  /* Group of action buttons (View Permit / View Invoice / Top Up) wraps
     into evenly-sized full-width buttons rather than crowding one line */
  .d-flex.flex-wrap.gap-2.mb-3 .btn {
    flex: 1 1 calc(50% - 0.5rem);
    min-width: 0;
  }

  /* Inspection-card grid view collapses to single column on phone */
  .inspection-card { font-size: 13px; }

  /* Tables that didn't get a card-view fallback can scroll horizontally */
  .table-responsive { -webkit-overflow-scrolling: touch; }

  /* Modal close button bigger on phones */
  .btn-close { padding: 14px; }

  /* Scrollbars on phones — make narrower but still visible */
  ::-webkit-scrollbar { width: 4px; height: 4px; }
}

/* ---- iOS-specific: prevent rubber-band over modal backdrop, fix vh ---- */
@supports (-webkit-touch-callout: none) {
  .modal.fade.show { overscroll-behavior: contain; }
  /* iOS Safari sometimes mis-reports vh; scanner uses dvh when available */
  @supports (height: 100dvh) {
    .scanner-video { max-height: 60dvh; }
  }
}
</style>